// Lightweight i18n: 7 languages
export const LANGS = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

export const T = {
  app_tagline: {
    es: "Popoyo Surf, Mareas, Clima y Comunidad!",
    en: "Popoyo Surf, Tides, Weather, & Community!",
    fr: "Popoyo Surf, Marées, Météo et Communauté !",
    de: "Popoyo Surf, Gezeiten, Wetter & Community!",
    zh: "Popoyo 冲浪、潮汐、天气和社区！",
    it: "Popoyo Surf, Maree, Meteo e Comunità!",
    ru: "Popoyo Сёрфинг, Приливы, Погода и Сообщество!",
  },
  app_subtagline: {
    es: "Reportes diarios y semanales para la costa Pacífica de Nicaragua.",
    en: "Daily & weekly reports for Nicaragua's Pacific coast.",
    fr: "Rapports quotidiens et hebdomadaires pour la côte Pacifique du Nicaragua.",
    de: "Tägliche & wöchentliche Berichte für die Pazifikküste Nicaraguas.",
    zh: "尼加拉瓜太平洋海岸的每日和每周报告。",
    it: "Report giornalieri e settimanali per la costa pacifica del Nicaragua.",
    ru: "Ежедневные и еженедельные отчёты для тихоокеанского побережья Nicaragua.",
  },
  install_app: {
    es: "Instalar app",
    en: "Install app",
    fr: "Installer",
    de: "Installieren",
    zh: "安装应用",
    it: "Installa app",
    ru: "Установить приложение",
  },
  menu: {
    es: "Menú",
    en: "Menu",
    fr: "Menu",
    de: "Menü",
    zh: "菜单",
    it: "Menu",
    ru: "Меню",
  },
  close: {
    es: "Cerrar",
    en: "Close",
    fr: "Fermer",
    de: "Schließen",
    zh: "关闭",
    it: "Chiudi",
    ru: "Закрыть",
  },
  login: {
    es: "Entrar",
    en: "Sign in",
    fr: "Connexion",
    de: "Anmelden",
    zh: "登录",
    it: "Accedi",
    ru: "Войти",
  },
  logout: {
    es: "Salir",
    en: "Sign out",
    fr: "Déconnexion",
    de: "Abmelden",
    zh: "退出",
    it: "Esci",
    ru: "Выйти",
  },
  register: {
    es: "Crear cuenta",
    en: "Sign up",
    fr: "Inscription",
    de: "Registrieren",
    zh: "注册",
    it: "Registrati",
    ru: "Зарегистрироваться",
  },
  email: {
    es: "Correo",
    en: "Email",
    fr: "Email",
    de: "E-Mail",
    zh: "电子邮箱",
    it: "Email",
    ru: "Email",
  },
  password: {
    es: "Contraseña",
    en: "Password",
    fr: "Mot de passe",
    de: "Passwort",
    zh: "密码",
    it: "Password",
    ru: "Пароль",
  },
  name: {
    es: "Nombre",
    en: "Name",
    fr: "Nom",
    de: "Name",
    zh: "名称",
    it: "Nome",
    ru: "Имя",
  },
  beach: {
    es: "Playa",
    en: "Beach",
    fr: "Plage",
    de: "Strand",
    zh: "海滩",
    it: "Spiaggia",
    ru: "Пляж",
  },
  today: {
    es: "Hoy",
    en: "Today",
    fr: "Aujourd'hui",
    de: "Heute",
    zh: "今天",
    it: "Oggi",
    ru: "Сегодня",
  },
  week: {
    es: "Semana",
    en: "Week",
    fr: "Semaine",
    de: "Woche",
    zh: "本周",
    it: "Settimana",
    ru: "Неделя",
  },
  surf_report: {
    es: "Reporte de surf",
    en: "Surf report",
    fr: "Rapport surf",
    de: "Surfbericht",
    zh: "冲浪报告",
    it: "Report surf",
    ru: "Сёрф-прогноз",
  },
  weather: {
    es: "Clima",
    en: "Weather",
    fr: "Météo",
    de: "Wetter",
    zh: "天气",
    it: "Meteo",
    ru: "Погода",
  },
  tides: {
    es: "Mareas",
    en: "Tides",
    fr: "Marées",
    de: "Gezeiten",
    zh: "潮汐",
    it: "Maree",
    ru: "Приливы",
  },
  moon: {
    es: "Luna",
    en: "Moon",
    fr: "Lune",
    de: "Mond",
    zh: "月相",
    it: "Luna",
    ru: "Луна",
  },
  alerts: {
    es: "Alertas",
    en: "Alerts",
    fr: "Alertes",
    de: "Warnungen",
    zh: "警报",
    it: "Allerte",
    ru: "Оповещения",
  },
  emergency: {
    es: "Emergencias",
    en: "Emergency",
    fr: "Urgences",
    de: "Notfälle",
    zh: "紧急情况",
    it: "Emergenza",
    ru: "Экстренная помощь",
  },
  chat: {
    es: "Chat comunitario",
    en: "Community chat",
    fr: "Tchat communauté",
    de: "Community-Chat",
    zh: "社区聊天",
    it: "Chat della comunità",
    ru: "Чат сообщества",
  },
  earthquakes: {
    es: "Sismos",
    en: "Earthquakes",
    fr: "Séismes",
    de: "Erdbeben",
    zh: "地震",
    it: "Terremoti",
    ru: "Землетрясения",
  },
  tsunami: {
    es: "Tsunami",
    en: "Tsunami",
    fr: "Tsunami",
    de: "Tsunami",
    zh: "海啸",
    it: "Tsunami",
    ru: "Цунами",
  },
  no_alerts: {
    es: "Sin alertas activas.",
    en: "No active alerts.",
    fr: "Aucune alerte active.",
    de: "Keine aktiven Warnungen.",
    zh: "无有效警报。",
    it: "Nessuna allerta attiva.",
    ru: "Активных оповещений нет.",
  },
  wave_height: {
    es: "Altura ola",
    en: "Wave height",
    fr: "Hauteur de vague",
    de: "Wellenhöhe",
    zh: "浪高",
    it: "Altezza onda",
    ru: "Высота волны",
  },
  wave_period: {
    es: "Período",
    en: "Period",
    fr: "Période",
    de: "Periode",
    zh: "周期",
    it: "Periodo",
    ru: "Период",
  },
  swell_forecast_title: {
    es: "Pronóstico de marejada · 7 días",
    en: "Swell forecast · 7 days",
    fr: "Prévision de houle · 7 jours",
    de: "Wellenvorhersage · 7 Tage",
    zh: "涌浪预报 · 7天",
    it: "Previsione mareggiata · 7 giorni",
    ru: "Прогноз волн · 7 дней",
  },
  swell_forecast_legend: {
    es: "Altura (m) · Período (s)",
    en: "Height (m) · Period (s)",
    fr: "Hauteur (m) · Période (s)",
    de: "Höhe (m) · Periode (s)",
    zh: "高度 (m) · 周期 (s)",
    it: "Altezza (m) · Periodo (s)",
    ru: "Высота (m) · Период (s)",
  },
  wind: {
    es: "Viento",
    en: "Wind",
    fr: "Vent",
    de: "Wind",
    zh: "风",
    it: "Vento",
    ru: "Ветер",
  },
  temp: {
    es: "Temp",
    en: "Temp",
    fr: "Temp",
    de: "Temp",
    zh: "温度",
    it: "Temp",
    ru: "Темп.",
  },
  high: {
    es: "Alta",
    en: "High",
    fr: "Haute",
    de: "Hoch",
    zh: "最高",
    it: "Max",
    ru: "Макс.",
  },
  low: {
    es: "Baja",
    en: "Low",
    fr: "Basse",
    de: "Niedrig",
    zh: "最低",
    it: "Min",
    ru: "Мин.",
  },
  sunrise: {
    es: "Amanecer",
    en: "Sunrise",
    fr: "Lever",
    de: "Sonnenaufgang",
    zh: "日出",
    it: "Alba",
    ru: "Восход",
  },
  sunset: {
    es: "Atardecer",
    en: "Sunset",
    fr: "Coucher",
    de: "Sonnenuntergang",
    zh: "日落",
    it: "Tramonto",
    ru: "Закат",
  },
  next_full_moons: {
    es: "Próximas lunas llenas",
    en: "Next full moons",
    fr: "Prochaines pleines lunes",
    de: "Nächste Vollmonde",
    zh: "接下来的满月",
    it: "Prossime lune piene",
    ru: "Следующие полнолуния",
  },
  illumination: {
    es: "Iluminación",
    en: "Illumination",
    fr: "Illumination",
    de: "Beleuchtung",
    zh: "亮度",
    it: "Illuminazione",
    ru: "Освещённость",
  },
  type_message: {
    es: "Escribe un mensaje…",
    en: "Type a message…",
    fr: "Écrire un message…",
    de: "Nachricht schreiben…",
    zh: "输入消息…",
    it: "Scrivi un messaggio…",
    ru: "Введите сообщение…",
  },
  send: {
    es: "Enviar",
    en: "Send",
    fr: "Envoyer",
    de: "Senden",
    zh: "发送",
    it: "Invia",
    ru: "Отправить",
  },
  login_to_chat: {
    es: "Entra para participar en el chat.",
    en: "Sign in to join the chat.",
    fr: "Connectez-vous pour discuter.",
    de: "Anmelden, um zu chatten.",
    zh: "登录以加入聊天。",
    it: "Accedi per partecipare alla chat.",
    ru: "Войдите, чтобы присоединиться к чату.",
  },
  call: {
    es: "Llamar",
    en: "Call",
    fr: "Appeler",
    de: "Anrufen",
    zh: "呼叫",
    it: "Chiama",
    ru: "Позвонить",
  },
  radar: {
    es: "Radar de lluvia",
    en: "Rain radar",
    fr: "Radar pluie",
    de: "Niederschlagsradar",
    zh: "降雨雷达",
    it: "Radar pioggia",
    ru: "Радар осадков",
  },
  radar_title: {
    es: "Radar meteorológico en vivo",
    en: "Live Doppler-style radar",
    fr: "Radar météo en direct",
    de: "Live-Wetterradar",
    zh: "实时多普勒式雷达",
    it: "Radar Doppler in tempo reale",
    ru: "Доплеровский радар в реальном времени",
  },
  radar_source: {
    es: "Fuente: RainViewer (NOAA / RAINBOW)",
    en: "Source: RainViewer (NOAA / RAINBOW)",
    fr: "Source : RainViewer",
    de: "Quelle: RainViewer",
    zh: "来源: RainViewer (NOAA / RAINBOW)",
    it: "Fonte: RainViewer (NOAA / RAINBOW)",
    ru: "Источник: RainViewer (NOAA / RAINBOW)",
  },
  radar_source_windy: {
    es: "Mapa animado en vivo · Windy.com",
    en: "Live animated map · Windy.com",
    fr: "Carte animée en direct · Windy.com",
    de: "Live-animierte Karte · Windy.com",
    zh: "实时动画地图 · Windy.com",
    it: "Mappa animata in tempo reale · Windy.com",
    ru: "Живая анимированная карта · Windy.com",
  },
  radar_footer_hint: {
    es: "Toca el mapa, reproduce la línea de tiempo y cambia capas para ver tormentas, huracanes y nubes.",
    en: "Tap the map, play the timeline, and switch layers to track storms, hurricanes & clouds.",
    fr: "Touchez la carte, lancez la timeline, changez de couches pour suivre tempêtes, ouragans & nuages.",
    de: "Karte antippen, Timeline starten und Ebenen wechseln, um Stürme, Hurrikane & Wolken zu verfolgen.",
    zh: "安装应用",
    it: "Installa app",
    ru: "Установить приложение",
  },
  radar_footer_hint_short: {
    es: "Toca y cambia capas",
    en: "Tap · switch layers",
    fr: "Toucher · changer",
    de: "Tippen · wechseln",
    zh: "轻点 · 切换图层",
    it: "Tocca · cambia strati",
    ru: "Нажмите · сменить слои",
  },
  fullscreen: {
    es: "Pantalla completa",
    en: "Fullscreen",
    fr: "Plein écran",
    de: "Vollbild",
    zh: "全屏",
    it: "Schermo intero",
    ru: "Полный экран",
  },
  exit_fullscreen: {
    es: "Salir",
    en: "Exit",
    fr: "Quitter",
    de: "Verlassen",
    zh: "退出",
    it: "Esci",
    ru: "Выйти",
  },
  radar_animate: {
    es: "Animar",
    en: "Animate",
    fr: "Animer",
    de: "Animieren",
    zh: "动画",
    it: "Anima",
    ru: "Анимация",
  },
  radar_play_overlay: {
    es: "Reproducir animación",
    en: "Play animation",
    fr: "Lancer l'animation",
    de: "Animation abspielen",
    zh: "播放动画",
    it: "Avvia animazione",
    ru: "Запустить анимацию",
  },
  share: {
    es: "Compartir",
    en: "Share",
    fr: "Partager",
    de: "Teilen",
    zh: "分享",
    it: "Condividi",
    ru: "Поделиться",
  },
  share_radar_title: {
    es: "Popoyo Radar Meteorológico",
    en: "Popoyo Weather Radar",
    fr: "Radar météo Popoyo",
    de: "Popoyo Wetterradar",
    zh: "Popoyo 天气雷达",
    it: "Radar Meteo Popoyo",
    ru: "Погодный радар Popoyo",
  },
  share_radar_text: {
    es: "Mira el radar de {layer} en vivo sobre Popoyo en Popoyo.app",
    en: "Check the live {layer} radar over Popoyo on Popoyo.app",
    fr: "Voir le radar {layer} en direct sur Popoyo sur Popoyo.app",
    de: "Live-{layer}-Radar über Popoyo auf Popoyo.app ansehen",
    zh: "查看圣胡安德尔苏尔上空的实时 {layer} 雷达，访问 Popoyo.app",
    it: "Guarda il radar {layer} in diretta su Popoyo su Popoyo.app",
    ru: "Смотрите радар {layer} в прямом эфире над Сан-Хуан-дель-Сур на Popoyo.app",
  },
  share_copied: {
    es: "Enlace copiado",
    en: "Link copied",
    fr: "Lien copié",
    de: "Link kopiert",
    zh: "链接已复制",
    it: "Link copiato",
    ru: "Ссылка скопирована",
  },
  share_failed: {
    es: "No se pudo compartir",
    en: "Couldn't share",
    fr: "Partage impossible",
    de: "Teilen fehlgeschlagen",
    zh: "无法分享",
    it: "Impossibile condividere",
    ru: "Не удалось поделиться",
  },
  open_full_map: {
    es: "Ver mapa completo",
    en: "Open full map",
    fr: "Carte complète",
    de: "Vollkarte öffnen",
    zh: "打开完整地图",
    it: "Apri mappa completa",
    ru: "Открыть полную карту",
  },
  layer_satellite: {
    es: "Satélite",
    en: "Satellite",
    fr: "Satellite",
    de: "Satellit",
    zh: "卫星",
    it: "Satellite",
    ru: "Спутник",
  },
  layer_clouds: {
    es: "Nubes",
    en: "Clouds",
    fr: "Nuages",
    de: "Wolken",
    zh: "云",
    it: "Nuvole",
    ru: "Облака",
  },
  layer_rain: {
    es: "Lluvia",
    en: "Rain",
    fr: "Pluie",
    de: "Regen",
    zh: "雨",
    it: "Pioggia",
    ru: "Дождь",
  },
  layer_radar: {
    es: "Radar",
    en: "Radar",
    fr: "Radar",
    de: "Radar",
    zh: "雷达",
    it: "Radar",
    ru: "Радар",
  },
  layer_thunder: {
    es: "Tormentas eléctricas",
    en: "Thunderstorms",
    fr: "Orages",
    de: "Gewitter",
    zh: "雷暴",
    it: "Temporali",
    ru: "Грозы",
  },
  layer_wind: {
    es: "Viento",
    en: "Wind",
    fr: "Vent",
    de: "Wind",
    zh: "风",
    it: "Vento",
    ru: "Ветер",
  },
  layer_gust: {
    es: "Ráfagas",
    en: "Wind gusts",
    fr: "Rafales",
    de: "Böen",
    zh: "阵风",
    it: "Raffiche di vento",
    ru: "Порывы ветра",
  },
  layer_hurricane: {
    es: "Huracanes",
    en: "Hurricanes",
    fr: "Ouragans",
    de: "Hurrikane",
    zh: "飓风",
    it: "Uragani",
    ru: "Ураганы",
  },
  layer_waves: {
    es: "Olas",
    en: "Waves",
    fr: "Vagues",
    de: "Wellen",
    zh: "波浪",
    it: "Onde",
    ru: "Волны",
  },
  layer_swell: {
    es: "Marejada",
    en: "Swell",
    fr: "Houle",
    de: "Dünung",
    zh: "涌浪",
    it: "Moto ondoso",
    ru: "Зыбь",
  },
  layer_swell2: {
    es: "Marejada 2°",
    en: "Secondary swell",
    fr: "Houle 2°",
    de: "2. Dünung",
    zh: "次级涌浪",
    it: "Moto ondoso secondario",
    ru: "Вторичная зыбь",
  },
  layer_wave_period: {
    es: "Período de olas",
    en: "Wave period",
    fr: "Période de vagues",
    de: "Wellenperiode",
    zh: "波周期",
    it: "Periodo dell'onda",
    ru: "Период волны",
  },
  layer_sst: {
    es: "Temperatura del mar",
    en: "Sea surface temp",
    fr: "Temp. de la mer",
    de: "Meerestemperatur",
    zh: "海面温度",
    it: "Temp. sup. mare",
    ru: "Темп. поверхности моря",
  },
  layer_currents: {
    es: "Corrientes",
    en: "Ocean currents",
    fr: "Courants",
    de: "Strömungen",
    zh: "洋流",
    it: "Correnti oceaniche",
    ru: "Океанские течения",
  },
  layer_pressure: {
    es: "Presión",
    en: "Pressure",
    fr: "Pression",
    de: "Druck",
    zh: "气压",
    it: "Pressione",
    ru: "Давление",
  },
  layer_temp: {
    es: "Temperatura",
    en: "Temperature",
    fr: "Température",
    de: "Temperatur",
    zh: "温度",
    it: "Temperatura",
    ru: "Температура",
  },
  layer_humidity: {
    es: "Humedad",
    en: "Humidity",
    fr: "Humidité",
    de: "Luftfeuchte",
    zh: "湿度",
    it: "Umidità",
    ru: "Влажность",
  },
  layer_dewpoint: {
    es: "Punto de rocío",
    en: "Dew point",
    fr: "Point de rosée",
    de: "Taupunkt",
    zh: "露点",
    it: "Punto di rugiada",
    ru: "Точка росы",
  },
  layer_uv: {
    es: "Índice UV",
    en: "UV index",
    fr: "Indice UV",
    de: "UV-Index",
    zh: "紫外线指数",
    it: "Indice UV",
    ru: "УФ-индекс",
  },
  layer_airq: {
    es: "Calidad del aire",
    en: "Air quality",
    fr: "Qualité de l'air",
    de: "Luftqualität",
    zh: "空气质量",
    it: "Qualità dell'aria",
    ru: "Качество воздуха",
  },
  layer_dust: {
    es: "Partículas finas",
    en: "Fine particles",
    fr: "Particules fines",
    de: "Feinstaub",
    zh: "细颗粒物",
    it: "Particelle fini",
    ru: "Мелкие частицы",
  },
  layer_drought: {
    es: "Sequía",
    en: "Drought",
    fr: "Sécheresse",
    de: "Dürre",
    zh: "干旱",
    it: "Siccità",
    ru: "Засуха",
  },
  layer_snow: {
    es: "Nieve",
    en: "Snow",
    fr: "Neige",
    de: "Schnee",
    zh: "雪",
    it: "Neve",
    ru: "Снег",
  },
  layer_visibility: {
    es: "Visibilidad",
    en: "Visibility",
    fr: "Visibilité",
    de: "Sicht",
    zh: "能见度",
    it: "Visibilità",
    ru: "Видимость",
  },
  now: {
    es: "Ahora",
    en: "Now",
    fr: "Maintenant",
    de: "Jetzt",
    zh: "现在",
    it: "Adesso",
    ru: "Сейчас",
  },
  past: {
    es: "Pasado",
    en: "Past",
    fr: "Passé",
    de: "Vergangenheit",
    zh: "过去",
    it: "Passato",
    ru: "Прошлое",
  },
  nowcast: {
    es: "Pronóstico",
    en: "Nowcast",
    fr: "Nowcast",
    de: "Nowcast",
    zh: "临近预报",
    it: "Nowcast",
    ru: "Прогноз на сейчас",
  },
  intensity: {
    es: "Intensidad",
    en: "Intensity",
    fr: "Intensité",
    de: "Intensität",
    zh: "强度",
    it: "Intensità",
    ru: "Интенсивность",
  },
  light: {
    es: "Ligera",
    en: "Light",
    fr: "Légère",
    de: "Leicht",
    zh: "轻",
    it: "Leggero",
    ru: "Слабый",
  },
  moderate: {
    es: "Moderada",
    en: "Moderate",
    fr: "Modérée",
    de: "Mäßig",
    zh: "中",
    it: "Moderato",
    ru: "Умеренный",
  },
  heavy: {
    es: "Fuerte",
    en: "Heavy",
    fr: "Forte",
    de: "Stark",
    zh: "大",
    it: "Forte",
    ru: "Сильный",
  },
  storm: {
    es: "Tormenta",
    en: "Storm",
    fr: "Tempête",
    de: "Sturm",
    zh: "风暴",
    it: "Tempesta",
    ru: "Шторм",
  },
  disclaimer: {
    es: "Popoyo.app es una plataforma comunitaria e informativa de clima, surf, mareas y alertas de seguridad para Popoyo y las playas cercanas del Pacífico. No publicamos noticias ni contenido político. En emergencias, siempre contacte a las autoridades oficiales directamente.",
    en: "Popoyo.app is an informational community weather, surf, tide, and safety-alert platform for Popoyo and nearby Pacific beaches. We do not publish news or political content. For emergencies, always contact official authorities directly.",
    fr: "Popoyo.app est une plateforme communautaire d'information sur la météo, le surf, les marées et les alertes de sécurité pour Popoyo et les plages du Pacifique. Nous ne publions pas d'actualités ni de contenu politique. En cas d'urgence, contactez toujours directement les autorités officielles.",
    de: "Popoyo.app ist eine informative Community-Plattform für Wetter, Surf, Gezeiten und Sicherheitswarnungen für Popoyo und die nahegelegenen Pazifikstrände. Wir veröffentlichen weder Nachrichten noch politische Inhalte. Bei Notfällen wenden Sie sich immer direkt an die offiziellen Behörden.",
    zh: "链接已复制",
    it: "Link copiato",
    ru: "Ссылка скопирована",
  },
  admin_post: {
    es: "Publicar alerta",
    en: "Post alert",
    fr: "Publier une alerte",
    de: "Warnung posten",
    zh: "发布警报",
    it: "Pubblica allerta",
    ru: "Опубликовать оповещение",
  },
  alert_title: {
    es: "Título",
    en: "Title",
    fr: "Titre",
    de: "Titel",
    zh: "标题",
    it: "Titolo",
    ru: "Заголовок",
  },
  alert_body: {
    es: "Mensaje",
    en: "Message",
    fr: "Message",
    de: "Nachricht",
    zh: "内容",
    it: "Messaggio",
    ru: "Сообщение",
  },
  severity: {
    es: "Severidad",
    en: "Severity",
    fr: "Sévérité",
    de: "Schwere",
    zh: "严重性",
    it: "Gravità",
    ru: "Серьёзность",
  },
  info: {
    es: "Info",
    en: "Info",
    fr: "Info",
    de: "Info",
    zh: "信息",
    it: "Info",
    ru: "Инфо",
  },
  warning: {
    es: "Aviso",
    en: "Warning",
    fr: "Avertissement",
    de: "Warnung",
    zh: "警告",
    it: "Avviso",
    ru: "Предупреждение",
  },
  from_popoyo: {
    es: "de Popoyo",
    en: "from Popoyo",
    fr: "de Popoyo",
    de: "von Popoyo",
    zh: "来自 Popoyo",
    it: "da Popoyo",
    ru: "от Popoyo",
  },
  loading_surf: {
    es: "Cargando surf y clima…",
    en: "Loading surf & weather…",
    fr: "Chargement surf & météo…",
    de: "Lade Surf & Wetter…",
    zh: "发布警报",
    it: "Pubblica avviso",
    ru: "Опубликовать оповещение",
  },
  sessions_eyebrow: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Community",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  sessions_title: {
    es: "Sesiones de surf",
    en: "Surf sessions",
    fr: "Sessions de surf",
    de: "Surf-Sessions",
    zh: "冲浪活动",
    it: "Sessioni di surf",
    ru: "Сёрф-сессии",
  },
  sessions_subtitle: {
    es: "Publica tu plan de surf y deja que otros se unan.",
    en: "Post your surf plan and let others join in.",
    fr: "Publiez votre plan de surf et laissez les autres vous rejoindre.",
    de: "Poste deinen Surf-Plan und lass andere mitsurfen.",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  sessions_empty: {
    es: "Aún no hay sesiones programadas. ¡Sé el primero en publicar una!",
    en: "No sessions scheduled yet. Be the first to post one!",
    fr: "Aucune session prévue. Soyez le premier !",
    de: "Noch keine Sessions geplant. Sei der Erste!",
    zh: "尚无已安排的活动。成为第一个发布活动的人！",
    it: "Nessuna sessione ancora programmata. Sii il primo a pubblicarne una!",
    ru: "Запланированных сессий пока нет. Станьте первым, кто её опубликует!",
  },
  session_new: {
    es: "Nueva sesión",
    en: "New session",
    fr: "Nouvelle session",
    de: "Neue Session",
    zh: "新建活动",
    it: "Nuova sessione",
    ru: "Новая сессия",
  },
  session_create: {
    es: "Publicar",
    en: "Post session",
    fr: "Publier",
    de: "Veröffentlichen",
    zh: "发布活动",
    it: "Pubblica sessione",
    ru: "Опубликовать сессию",
  },
  session_join: {
    es: "Unirme",
    en: "Join",
    fr: "Rejoindre",
    de: "Beitreten",
    zh: "加入",
    it: "Partecipa",
    ru: "Присоединиться",
  },
  session_leave: {
    es: "Salir",
    en: "Leave",
    fr: "Quitter",
    de: "Verlassen",
    zh: "离开",
    it: "Lascia",
    ru: "Покинуть",
  },
  session_full: {
    es: "Lleno",
    en: "Full",
    fr: "Complet",
    de: "Voll",
    zh: "已满",
    it: "Completo",
    ru: "Мест нет",
  },
  session_delete: {
    es: "Eliminar",
    en: "Delete",
    fr: "Supprimer",
    de: "Löschen",
    zh: "删除",
    it: "Elimina",
    ru: "Удалить",
  },
  session_delete_confirm: {
    es: "¿Eliminar esta sesión?",
    en: "Delete this session?",
    fr: "Supprimer cette session ?",
    de: "Diese Session löschen?",
    zh: "删除此活动？",
    it: "Eliminare questa sessione?",
    ru: "Удалить эту сессию?",
  },
  session_date: {
    es: "Día",
    en: "Date",
    fr: "Date",
    de: "Datum",
    zh: "日期",
    it: "Data",
    ru: "Дата",
  },
  session_time: {
    es: "Hora",
    en: "Time",
    fr: "Heure",
    de: "Zeit",
    zh: "时间",
    it: "Ora",
    ru: "Время",
  },
  session_max: {
    es: "Máx",
    en: "Max",
    fr: "Max",
    de: "Max",
    zh: "最多",
    it: "Max",
    ru: "Макс.",
  },
  session_note_placeholder: {
    es: "ej. Dawn patrol en Popoyo, café después. ¡Únanse!",
    en: "e.g. Dawn patrol at Popoyo, coffee after. Come join!",
    fr: "ex. Dawn patrol à Popoyo, café après. Rejoignez !",
    de: "z.B. Dawn Patrol an Popoyo, Kaffee danach. Komm mit!",
    zh: "新活动",
    it: "Nuova sessione",
    ru: "Новая сессия",
  },
  session_signin_to_join: {
    es: "Entra para unirte.",
    en: "Sign in to join.",
    fr: "Connectez-vous pour rejoindre.",
    de: "Anmelden, um mitzumachen.",
    zh: "登录以加入。",
    it: "Accedi per partecipare.",
    ru: "Войдите, чтобы присоединиться.",
  },
  session_signin_to_post: {
    es: "Entra para publicar",
    en: "Sign in to post",
    fr: "Connexion pour publier",
    de: "Anmelden zum Posten",
    zh: "登录以发布",
    it: "Accedi per pubblicare",
    ru: "Войдите, чтобы опубликовать",
  },
  help_community_eyebrow: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Community",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  help_community_title: {
    es: "Ayuda a la comunidad",
    en: "Help the Community",
    fr: "Aidez la communauté",
    de: "Hilf der Gemeinde",
    zh: "帮助社区",
    it: "Aiuta la Comunità",
    ru: "Помогите Сообществу",
  },
  help_community_subtitle: {
    es: "Apoya a las fundaciones de Popoyo que cuidan a nuestra gente y a nuestros animales.",
    en: "Support the Popoyo foundations that care for our people and our animals.",
    fr: "Soutenez les fondations de Popoyo qui prennent soin de notre communauté.",
    de: "Unterstütze die Stiftungen von Popoyo, die sich um unsere Menschen und Tiere kümmern.",
    zh: "登录以加入。",
    it: "Accedi per partecipare.",
    ru: "Войдите, чтобы присоединиться.",
  },
  help_community_footer_note: {
    es: "Las donaciones van directamente a cada organización. Popoyo.app no recibe ninguna comisión.",
    en: "Donations go directly to each organization. Popoyo.app takes no cut.",
    fr: "Les dons vont directement à chaque organisation. Popoyo.app ne prend aucune commission.",
    de: "Spenden gehen direkt an jede Organisation. Popoyo.app behält keine Gebühr ein.",
    zh: "捐款将直接捐给各个组织。Popoyo.app 不收取任何费用。",
    it: "Le donazioni vanno direttamente a ciascuna organizzazione. Popoyo.app non trattiene alcuna commissione.",
    ru: "Пожертвования поступают напрямую в каждую организацию. Popoyo.app не берёт комиссию.",
  },
  np_donate: {
    es: "Donar",
    en: "Donate",
    fr: "Faire un don",
    de: "Spenden",
    zh: "捐赠",
    it: "Dona",
    ru: "Пожертвовать",
  },
  np_visit: {
    es: "Visitar sitio",
    en: "Visit site",
    fr: "Voir le site",
    de: "Webseite",
    zh: "访问网站",
    it: "Visita il sito",
    ru: "Посетить сайт",
  },
  np_add_title: {
    es: "Agrega tu ONG de Popoyo / Tola",
    en: "Add your Popoyo / Tola Non-Profit",
    fr: "Ajoutez votre association de Popoyo / Tola",
    de: "Füge deine Popoyo / Tola-Non-Profit hinzu",
    zh: "添加你的 Popoyo / Tola 非营利组织",
    it: "Aggiungi la tua ONLUS di Popoyo / Tola",
    ru: "Добавьте свою НКО из Попойо / Толы",
  },
  np_add_sub: {
    es: "¿Diriges o conoces una organización sin fines de lucro local? Cuéntanos y la destacamos aquí para toda la comunidad.",
    en: "Run or know a local non-profit? Tell us and we'll feature it here for the whole community.",
    fr: "Vous gérez ou connaissez une association locale ? Dites-le-nous et nous la mettrons en avant ici.",
    de: "Leitest oder kennst du eine lokale Non-Profit? Sag Bescheid und wir stellen sie hier vor.",
    zh: "经营或了解本地非营利组织？告诉我们，我们会在这里展示。",
    it: "Gestisci o conosci una ONLUS locale? Faccelo sapere e la mostreremo qui.",
    ru: "Ведёте или знаете местную НКО? Расскажите — мы разместим её здесь.",
  },
  np_add_cta: {
    es: "Sugerir una ONG",
    en: "Suggest a non-profit",
    fr: "Proposer une association",
    de: "Non-Profit vorschlagen",
    zh: "推荐一个非营利组织",
    it: "Suggerisci una ONLUS",
    ru: "Предложить НКО",
  },
  np_curious_badge: {
    es: "Educación · Niños",
    en: "Education · Kids",
    fr: "Éducation · Enfants",
    de: "Bildung · Kinder",
    zh: "教育 · 儿童",
    it: "Istruzione · Bambini",
    ru: "Образование · Дети",
  },
  np_curious_tagline: {
    es: "Programa de educación y mentoría que despierta la curiosidad y abre oportunidades para niños y jóvenes de Popoyo.",
    en: "Education and mentorship that sparks curiosity and opens opportunities for kids and youth in Popoyo.",
    fr: "Éducation et mentorat qui éveillent la curiosité et ouvrent des opportunités aux enfants de Popoyo.",
    de: "Bildung und Mentoring, das die Neugier weckt und Chancen für Kinder und Jugendliche in Popoyo eröffnet.",
    zh: "捐赠",
    it: "Istruzione e tutoraggio che accendono la curiosità e aprono opportunità per bambini e giovani a Popoyo.",
    ru: "Пожертвовать",
  },
  np_sos_badge: {
    es: "Rescate animal",
    en: "Animal rescue",
    fr: "Sauvetage animal",
    de: "Tierrettung",
    zh: "动物救援",
    it: "Soccorso animali",
    ru: "Спасение животных",
  },
  np_sos_tagline: {
    es: "Rescate, esterilización y atención veterinaria para perros y gatos callejeros en la región de Popoyo.",
    en: "Rescue, sterilization, and vet care for the street dogs and cats of the Popoyo area.",
    fr: "Sauvetage, stérilisation et soins vétérinaires pour les chiens et chats des rues de Popoyo.",
    de: "Rettung, Sterilisation und tierärztliche Versorgung für Straßenhunde und -katzen rund um Popoyo.",
    zh: "动物救援",
    it: "Soccorso animali",
    ru: "Спасение животных",
  },
  np_elis_badge: {
    es: "Conservación de ballenas",
    en: "Whale conservation",
    fr: "Conservation des baleines",
    de: "Walschutz",
    zh: "鲸鱼保护",
    it: "Conservazione delle balene",
    ru: "Сохранение китов",
  },
  np_elis_tagline: {
    es: "Investigación, protección y educación sobre ballenas y delfines en el Pacífico de Nicaragua — ciencia marina liderada desde Popoyo.",
    en: "Whale and dolphin research, protection, and education along Nicaragua's Pacific coast — marine science led from Popoyo.",
    fr: "Recherche, protection et éducation sur les baleines et dauphins du Pacifique nicaraguayen — science marine basée à Popoyo.",
    de: "Wal- und Delfinforschung, Schutz und Bildung an Nicaraguas Pazifikküste — Meereswissenschaft aus Popoyo.",
    zh: "鲸鱼保护",
    it: "Conservazione delle balene",
    ru: "Сохранение китов",
  },
  np_believe_badge: {
    es: "Educación bilingüe",
    en: "Bilingual education",
    fr: "Éducation bilingue",
    de: "Zweisprachige Bildung",
    zh: "双语教育",
    it: "Educazione bilingue",
    ru: "Двуязычное образование",
  },
  np_believe_tagline: {
    es: "Educación bilingüe y formación integral para niñas y niños de Popoyo — invertir en la próxima generación de Nicaragua.",
    en: "Bilingual education and whole-child development for kids in Popoyo — investing in Nicaragua's next generation.",
    fr: "Éducation bilingue et développement global pour les enfants de Popoyo — investir dans la prochaine génération du Nicaragua.",
    de: "Zweisprachige Bildung und ganzheitliche Förderung für Kinder in Popoyo — Investition in Nicaraguas nächste Generation.",
    zh: "双语教育",
    it: "Educazione bilingue",
    ru: "Двуязычное образование",
  },
  np_brugger_badge: {
    es: "Comunidad · Bienestar",
    en: "Community · Wellbeing",
    fr: "Communauté · Bien-être",
    de: "Gemeinschaft · Wohl",
    zh: "社区 · 福祉",
    it: "Comunità · Benessere",
    ru: "Сообщество · Благополучие",
  },
  np_brugger_tagline: {
    es: "Programas comunitarios que apoyan a familias, jóvenes y proyectos sociales en Nicaragua.",
    en: "Community programs supporting families, youth, and social projects across Nicaragua.",
    fr: "Programmes communautaires soutenant les familles, les jeunes et les projets sociaux au Nicaragua.",
    de: "Gemeinschaftsprogramme zur Unterstützung von Familien, Jugendlichen und sozialen Projekten in Nicaragua.",
    zh: "社区 · 福祉",
    it: "Comunità · Benessere",
    ru: "Сообщество · Благополучие",
  },
  live_nicaragua: {
    es: "En vivo · Nicaragua",
    en: "Live · Nicaragua",
    fr: "En direct · Nicaragua",
    de: "Live · Nicaragua",
    zh: "直播 · Nicaragua",
    it: "In diretta · Nicaragua",
    ru: "Прямой эфир · Nicaragua",
  },
  nav_home: {
    es: "Inicio",
    en: "Home",
    fr: "Accueil",
    de: "Start",
    zh: "首页",
    it: "Home",
    ru: "Главная",
  },
  nav_history: {
    es: "Historia",
    en: "History",
    fr: "Histoire",
    de: "Geschichte",
    zh: "历史",
    it: "Storia",
    ru: "История",
  },
  nav_weather: {
    es: "Clima",
    en: "Weather",
    fr: "Météo",
    de: "Wetter",
    zh: "天气",
    it: "Meteo",
    ru: "Погода",
  },
  nav_surf: {
    es: "Surf",
    en: "Surf",
    fr: "Surf",
    de: "Surf",
    zh: "冲浪",
    it: "Surf",
    ru: "Сёрф",
  },
  nav_beaches: {
    es: "Playas",
    en: "Beaches",
    fr: "Plages",
    de: "Strände",
    zh: "海滩",
    it: "Spiagge",
    ru: "Пляжи",
  },
  nav_community: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Gemeinschaft",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  nav_profile: {
    es: "Perfil",
    en: "Profile",
    fr: "Profil",
    de: "Profil",
    zh: "个人资料",
    it: "Profilo",
    ru: "Профиль",
  },
  nav_admin: {
    es: "Admin",
    en: "Admin",
    fr: "Admin",
    de: "Admin",
    zh: "管理",
    it: "Admin",
    ru: "Админ",
  },
  nav_taxi: {
    es: "Nicaragua Taxi",
    en: "Nicaragua Taxi",
    fr: "Nicaragua Taxi",
    de: "Nicaragua Taxi",
    zh: "尼加拉瓜出租车",
    it: "Nicaragua Taxi",
    ru: "Никарагуа Такси",
  },
  nav_locals: { es: "Locales Popoyo", en: "Popoyo Locals", fr: "Locaux Popoyo", de: "Popoyo Einheimische", zh: "Popoyo 本地", it: "Locali Popoyo", ru: "Локальные Popoyo" },
  nav_blog: { es: "Blog", en: "Blog", fr: "Blog", de: "Blog", zh: "博客", it: "Blog", ru: "Блог" },
  locals_hero_eyebrow: { es: "Comunidad · Popoyo", en: "Community · Popoyo", fr: "Communauté · Popoyo", de: "Community · Popoyo", zh: "社区 · 圣胡安德尔苏尔", it: "Comunità · Popoyo", ru: "Сообщество · Сан-Хуан-дель-Сур" },
  locals_hero_title: { es: "Locales Popoyo", en: "Popoyo Locals", fr: "Locaux Popoyo", de: "Popoyo Einheimische", zh: "Popoyo 本地", it: "Locali di Popoyo", ru: "Местные Popoyo" },
  locals_hero_subtitle: {
    es: "Tu hub para chat comunitario, negocios locales, transporte y más en Popoyo. Cualquiera puede explorar; inicia sesión para participar.",
    en: "Your hub for community chat, local businesses, transportation and more in Popoyo. Anyone can browse; sign in to take part.",
    fr: "Votre plateforme pour le chat communautaire, les commerces locaux, le transport et plus à Popoyo. Tout le monde peut consulter ; connectez-vous pour participer.",
    de: "Dein Hub für Community-Chat, lokale Unternehmen, Transport und mehr in Popoyo. Jeder kann stöbern; melde dich an, um mitzumachen.",
    zh: "圣胡安德尔苏尔的社区聊天、本地商家、交通等中心。任何人都可以浏览；登录后即可参与。",
    it: "Il tuo hub per chat di comunità, attività locali, trasporti e altro a Popoyo. Chiunque può sfogliare; accedi per partecipare.",
    ru: "Ваш центр чата сообщества, местных компаний, транспорта и многого другого в Сан-Хуан-дель-Сур. Любой может просматривать; войдите, чтобы участвовать.",
  },
  locals_chat_eyebrow: { es: "Chat en vivo", en: "Live chat", fr: "Chat en direct", de: "Live-Chat", zh: "实时聊天", it: "Chat dal vivo", ru: "Живой чат" },
  locals_chat_title: { es: "Chat comunitario", en: "Community chat", fr: "Chat communautaire", de: "Community-Chat", zh: "社区聊天", it: "Chat della comunità", ru: "Чат сообщества" },
  locals_chat_subtitle: {
    es: "Cualquiera puede leer. Inicia sesión para chatear con locales y viajeros en tiempo real.",
    en: "Anyone can read. Sign in to chat with locals and travelers in real time.",
    fr: "Tout le monde peut lire. Connectez-vous pour discuter avec locaux et voyageurs en temps réel.",
    de: "Jeder kann lesen. Melde dich an, um in Echtzeit mit Einheimischen und Reisenden zu chatten.",
    zh: "任何人都可阅读。登录后即可与本地人和旅行者实时聊天。",
    it: "Chiunque può leggere. Accedi per chattare con locali e viaggiatori in tempo reale.",
    ru: "Любой может читать. Войдите, чтобы общаться с местными и путешественниками в реальном времени.",
  },
  locals_biz_eyebrow: { es: "Negocios locales", en: "Local businesses", fr: "Commerces locaux", de: "Lokale Unternehmen", zh: "本地商家", it: "Attività locali", ru: "Местные бизнесы" },
  locals_biz_title: { es: "Apoya a Popoyo", en: "Support Popoyo", fr: "Soutenez Popoyo", de: "Unterstütze Popoyo", zh: "支持 Popoyo", it: "Sostieni Popoyo", ru: "Поддержите Popoyo" },
  locals_biz_subtitle: {
    es: "Sitios web de aliados locales que hemos construido en Popoyo.",
    en: "Local partner sites we've built in Popoyo.",
    fr: "Sites de partenaires locaux que nous avons construits à Popoyo.",
    de: "Lokale Partner-Websites, die wir in Popoyo erstellt haben.",
    zh: "我们在圣胡安德尔苏尔为本地合作伙伴搭建的网站。",
    it: "Siti di partner locali che abbiamo costruito a Popoyo.",
    ru: "Сайты местных партнёров, которые мы создали в Сан-Хуан-дель-Сур.",
  },
  locals_biz_add: { es: "Sugerir negocio", en: "Suggest a business", fr: "Suggérer un commerce", de: "Unternehmen vorschlagen", zh: "推荐商家", it: "Suggerisci un'attività", ru: "Предложить бизнес" },
  locals_biz_signin_to_add: { es: "Inicia sesión para agregar", en: "Sign in to add", fr: "Connectez-vous pour ajouter", de: "Anmelden zum Hinzufügen", zh: "登录以添加", it: "Accedi per aggiungere", ru: "Войдите, чтобы добавить" },
  locals_taxi_eyebrow: { es: "Transporte", en: "Transportation", fr: "Transport", de: "Transport", zh: "交通", it: "Trasporti", ru: "Транспорт" },
  locals_taxi_title: { es: "Nicaragua Taxi Services", en: "Nicaragua Taxi Services", fr: "Nicaragua Taxi Services", de: "Nicaragua Taxi Services", zh: "Nicaragua Taxi Services", it: "Nicaragua Taxi Services", ru: "Nicaragua Taxi Services" },
  locals_taxi_subtitle: {
    es: "Aliado oficial de transporte privado de Popoyo.app.",
    en: "Official private transportation partner of Popoyo.app.",
    fr: "Partenaire officiel de transport privé de Popoyo.app.",
    de: "Offizieller privater Transportpartner von Popoyo.app.",
    zh: "Popoyo.app 官方私人交通合作伙伴。",
    it: "Partner ufficiale di trasporto privato di Popoyo.app.",
    ru: "Официальный партнёр Popoyo.app по частному транспорту.",
  },
  locals_cs_eyebrow: { es: "Próximamente", en: "Coming soon", fr: "Bientôt disponible", de: "Demnächst", zh: "即将推出", it: "Prossimamente", ru: "Скоро" },
  locals_cs_title: { es: "Más para Locales Popoyo", en: "More for Popoyo Locals", fr: "Plus pour les Locaux Popoyo", de: "Mehr für Popoyo Einheimische", zh: "更多 Popoyo 本地内容", it: "Altro per i Locali Popoyo", ru: "Больше для местных Popoyo" },
  locals_cs_subtitle: {
    es: "Funciones que estamos construyendo. ¿Tienes una idea? ¡Envíala!",
    en: "Features we're building. Got an idea? Send it in!",
    fr: "Fonctionnalités en construction. Vous avez une idée ? Envoyez-la !",
    de: "Funktionen, die wir bauen. Idee? Schick sie ein!",
    zh: "我们正在构建的功能。有想法？告诉我们！",
    it: "Funzionalità in arrivo. Hai un'idea? Inviala!",
    ru: "Функции, которые мы строим. Есть идея? Присылайте!",
  },
  locals_coming_soon: { es: "Próximamente", en: "Coming soon", fr: "Bientôt", de: "Demnächst", zh: "即将推出", it: "In arrivo", ru: "Скоро" },
  locals_cs_directory_title: { es: "Directorio de locales", en: "Locals directory", fr: "Répertoire des locaux", de: "Verzeichnis der Einheimischen", zh: "本地人名录", it: "Elenco dei locali", ru: "Справочник местных" },
  locals_cs_directory_desc: { es: "Encuentra y contacta residentes — instructores de surf, chefs, agentes, terapeutas y más.", en: "Find and reach out to residents — surf instructors, chefs, agents, therapists & more.", fr: "Trouvez et contactez des résidents — instructeurs de surf, chefs, agents, thérapeutes et plus.", de: "Finde und kontaktiere Einheimische — Surflehrer, Köche, Makler, Therapeuten & mehr.", zh: "查找并联系居民——冲浪教练、厨师、经纪人、治疗师等。", it: "Trova e contatta i residenti — istruttori di surf, chef, agenti, terapisti e altro.", ru: "Найдите и свяжитесь с местными — инструкторами серфинга, шеф-поварами, агентами, терапевтами и др." },
  locals_cs_buy_sell_title: { es: "Compra y venta Popoyo", en: "Buy & sell Popoyo", fr: "Achat & vente Popoyo", de: "Kaufen & verkaufen Popoyo", zh: "Popoyo 二手买卖", it: "Compra & vendi Popoyo", ru: "Купля и продажа Popoyo" },
  locals_cs_buy_sell_desc: { es: "Tablero local para tablas de surf, muebles, motos, autos y herramientas.", en: "Local board for surfboards, furniture, motos, cars and tools.", fr: "Tableau local pour planches, meubles, motos, voitures et outils.", de: "Lokales Board für Surfboards, Möbel, Motorräder, Autos und Werkzeuge.", zh: "冲浪板、家具、摩托、汽车与工具的本地交易板。", it: "Bacheca locale per tavole da surf, mobili, moto, auto e attrezzi.", ru: "Локальная доска для досок для серфинга, мебели, мотоциклов, машин и инструментов." },
  locals_cs_events_title: { es: "Eventos y recaudaciones", en: "Events & fundraisers", fr: "Événements & collectes", de: "Veranstaltungen & Spenden", zh: "活动与募款", it: "Eventi & raccolte", ru: "События и сборы" },
  locals_cs_events_desc: { es: "Calendario mensual de eventos comunitarios y fondos benéficos.", en: "Monthly calendar of community events and charity drives.", fr: "Calendrier mensuel des événements communautaires et collectes.", de: "Monatlicher Kalender für Community-Events und Spendenaktionen.", zh: "每月社区活动与慈善募款日历。", it: "Calendario mensile di eventi comunitari e raccolte fondi.", ru: "Ежемесячный календарь общественных мероприятий и благотворительных акций." },
  locals_cs_features_title: { es: "Conoce a los locales", en: "Meet the locals", fr: "Rencontrez les locaux", de: "Lerne die Einheimischen kennen", zh: "认识本地人", it: "Conosci i locali", ru: "Познакомьтесь с местными" },
  locals_cs_features_desc: { es: "Historias destacadas de personas que dan vida a Popoyo.", en: "Feature stories on the people who make Popoyo what it is.", fr: "Portraits des personnes qui font de Popoyo ce qu'il est.", de: "Reportagen über die Menschen, die Popoyo prägen.", zh: "讲述构成 Popoyo 这座小城的人们的故事。", it: "Storie speciali sulle persone che rendono Popoyo ciò che è.", ru: "Очерки о людях, которые делают Popoyo таким, какой он есть." },
  locals_suggest_idea: { es: "Sugerir una idea", en: "Suggest an idea", fr: "Suggérer une idée", de: "Idee vorschlagen", zh: "提出想法", it: "Suggerisci un'idea", ru: "Предложить идею" },
  nicaragua_taxi_tagline: {
    es: "Transporte privado confiable en Popoyo y toda Nicaragua.",
    en: "Reliable private transportation around Popoyo and across Nicaragua.",
    fr: "Transport privé fiable à Popoyo et dans tout le Nicaragua.",
    de: "Zuverlässiger Privattransport in Popoyo und ganz Nicaragua.",
    zh: "圣胡安德尔苏尔及尼加拉瓜全国可靠的私人交通服务。",
    it: "Trasporto privato affidabile a Popoyo e in tutto il Nicaragua.",
    ru: "Надёжные частные перевозки в Сан-Хуан-дель-Сур и по всей Никарагуа.",
  },

  /* History teaser + page chrome */
  history_eyebrow: {
    es: "Archivo · Popoyo",
    en: "Archive · Popoyo",
    fr: "Archives · Popoyo",
    de: "Archiv · Popoyo",
    zh: "存档 · Popoyo",
    it: "Archivio · Popoyo",
    ru: "Архив · Popoyo",
  },
  history_title: {
    es: "La historia de Popoyo",
    en: "The History of Popoyo",
    fr: "L'histoire de Popoyo",
    de: "Die Geschichte von Popoyo",
    zh: "Popoyo 的历史",
    it: "La Storia di Popoyo",
    ru: "История Popoyo",
  },
  history_subtitle: {
    es: "De pueblo pesquero de Tola a capital surfista mundial de la Costa Esmeralda de Nicaragua. Fotos, historias y capítulos del archivo.",
    en: "From a Tola fishing village to the world-class surf capital of Nicaragua's Emerald Coast. Photos, stories, and chapters from the archive.",
    fr: "D'un village de pêcheurs de Tola à la capitale mondiale du surf de la Côte d'Émeraude du Nicaragua. Photos, histoires et chapitres des archives.",
    de: "Vom Fischerdorf in Tola zur Weltklasse-Surf-Hauptstadt der Smaragdküste Nicaraguas. Fotos, Geschichten und Kapitel aus dem Archiv.",
    zh: "从托拉的渔村到尼加拉瓜翡翠海岸的世界级冲浪之都。照片、故事与档案篇章。",
    it: "Da villaggio di pescatori di Tola a capitale mondiale del surf della Costa Smeralda del Nicaragua. Foto, storie e capitoli dall'archivio.",
    ru: "От рыбацкой деревни в Толе до мировой столицы сёрфинга Изумрудного берега Никарагуа. Фото, истории и главы из архива.",
  },
  history_cta: {
    es: "Leer la historia de Popoyo",
    en: "Read the History of Popoyo",
    fr: "Lire l'histoire de Popoyo",
    de: "Die Geschichte von Popoyo lesen",
    zh: "阅读 Popoyo 的历史",
    it: "Leggi la Storia di Popoyo",
    ru: "Читать историю Popoyo",
  },
  history_in_archive: {
    es: "En este archivo",
    en: "In this archive",
    fr: "Dans ces archives",
    de: "In diesem Archiv",
    zh: "在此存档中",
    it: "In questo archivio",
    ru: "В этом архиве",
  },
  history_more_soon: {
    es: "Próximamente más capítulos e imágenes históricas — comparte las tuyas etiquetando #Popoyoapp o escribiendo al administrador en el chat comunitario.",
    en: "More chapters and historic photos coming soon — share yours by tagging #Popoyoapp or messaging the admin in the community chat.",
    fr: "Plus de chapitres et de photos historiques à venir — partagez les vôtres en taguant #Popoyoapp ou en écrivant à l'administrateur dans le chat communautaire.",
    de: "Bald folgen weitere Kapitel und historische Fotos — teile deine, indem du #Popoyoapp markierst oder den Administrator im Community-Chat anschreibst.",
    zh: "阅读 Popoyo 的历史",
    it: "Leggi la Storia di Popoyo",
    ru: "Прочитать Историю Popoyo",
  },
  history_lang_note: {
    es: "",
    en: "",
    fr: "",
    de: "",
    zh: "",
    it: "",
    ru: "",
  },

  /* History article titles */
  hist_overview_title: {
    es: "La historia de Popoyo, Nicaragua",
    en: "The History of Popoyo, Nicaragua",
    fr: "L'histoire de Popoyo, Nicaragua",
    de: "Die Geschichte von Popoyo, Nicaragua",
    zh: "Popoyo（尼加拉瓜）的历史",
    it: "La Storia di Popoyo, Nicaragua",
    ru: "История Popoyo, Nicaragua",
  },
  hist_roots_title: {
    es: "Pesca, agricultura y raíces indígenas",
    en: "Fishing, Farming & Indigenous Roots",
    fr: "Pêche, agriculture et racines indigènes",
    de: "Fischerei, Landwirtschaft & indigene Wurzeln",
    zh: "渔业、农业与原住民根源",
    it: "Pesca, agricoltura e radici indigene",
    ru: "Рыболовство, земледелие и коренные корни",
  },
  hist_reform_title: {
    es: "Revolución, reforma agraria y el giro de 1990",
    en: "Revolution, Land Reform & the 1990 Turn",
    fr: "Révolution, réforme agraire et le tournant de 1990",
    de: "Revolution, Landreform & die Wende von 1990",
    zh: "革命、土地改革与 1990 年的转折",
    it: "Rivoluzione, riforma agraria e la svolta del 1990",
    ru: "Революция, земельная реформа и поворот 1990 года",
  },
  hist_tsunami_title: {
    es: "El tsunami de 1992 y la reconstrucción del pueblo",
    en: "The 1992 Tsunami & Rebuilding the Village",
    fr: "Le tsunami de 1992 et la reconstruction du village",
    de: "Der Tsunami von 1992 & der Wiederaufbau des Dorfes",
    zh: "1992 年海啸与村庄重建",
    it: "Lo tsunami del 1992 e la ricostruzione del villaggio",
    ru: "Цунами 1992 года и восстановление деревни",
  },
  hist_surflodge_title: {
    es: "Popoyo Surf Lodge y el nacimiento del turismo de surf",
    en: "Popoyo Surf Lodge & the Birth of Surf Tourism",
    fr: "Popoyo Surf Lodge et la naissance du tourisme de surf",
    de: "Popoyo Surf Lodge & die Geburt des Surf-Tourismus",
    zh: "Popoyo 冲浪旅馆与冲浪旅游的诞生",
    it: "Popoyo Surf Lodge e la nascita del turismo del surf",
    ru: "Popoyo Surf Lodge и рождение сёрф-туризма",
  },
  hist_colorado_title: {
    es: "Playa Colorado, Panga Drops y Hacienda Iguana",
    en: "Playa Colorado, Panga Drops & Hacienda Iguana",
    fr: "Playa Colorado, Panga Drops et Hacienda Iguana",
    de: "Playa Colorado, Panga Drops & Hacienda Iguana",
    zh: "Playa Colorado、Panga Drops 与 Hacienda Iguana",
    it: "Playa Colorado, Panga Drops e Hacienda Iguana",
    ru: "Плайя-Колорадо, Панга-Дропс и Асьенда-Игуана",
  },
  hist_emerald_title: {
    es: "El Astillero y la Costa Esmeralda hoy",
    en: "El Astillero & the Emerald Coast Today",
    fr: "El Astillero et la Côte d'Émeraude aujourd'hui",
    de: "El Astillero & die Smaragdküste heute",
    zh: "El Astillero 与今日的翡翠海岸",
    it: "El Astillero e la Costa Smeralda oggi",
    ru: "Эль-Астильеро и Изумрудный берег сегодня",
  },

  /* Live Surf Report */
  live_title: {
    es: "Reporte de Surf en Vivo",
    en: "Live Surf Report",
    fr: "Rapport de Surf en Direct",
    de: "Live-Surf-Report",
    zh: "实时冲浪报告",
    it: "Report Surf in Diretta",
    ru: "Прямой сёрф-репорт",
  },
  live_badge: {
    es: "EN VIVO",
    en: "LIVE",
    fr: "EN DIRECT",
    de: "LIVE",
    zh: "直播",
    it: "IN DIRETTA",
    ru: "В ЭФИРЕ",
  },
  live_updated: {
    es: "Actualizado",
    en: "Updated",
    fr: "Mis à jour",
    de: "Aktualisiert",
    zh: "更新于",
    it: "Aggiornato",
    ru: "Обновлено",
  },
  live_none_title: {
    es: "Feed de surf en vivo próximamente",
    en: "Live surf feed coming soon",
    fr: "Flux de surf en direct bientôt disponible",
    de: "Live-Surf-Feed folgt in Kürze",
    zh: "实时冲浪画面即将上线",
    it: "Feed surf in diretta in arrivo",
    ru: "Прямая трансляция сёрфа скоро",
  },
  live_none_sub: {
    es: "Vuelve pronto — transmitiremos las olas de Playa Popoyo aquí mismo.",
    en: "Check back soon — we'll be streaming the waves at Playa Popoyo right here.",
    fr: "Revenez bientôt — nous diffuserons les vagues de Playa Popoyo ici même.",
    de: "Schau bald wieder vorbei — wir streamen die Wellen von Playa Popoyo genau hier.",
    zh: "敬请期待 —— 我们将在这里直播 Playa Popoyo 的海浪。",
    it: "Torna presto — trasmetteremo le onde di Playa Popoyo proprio qui.",
    ru: "Загляните позже — мы будем транслировать волны Плайя-Попойо прямо здесь.",
  },
  live_admin_title: {
    es: "Feed en vivo (admin)",
    en: "Live feed (admin)",
    fr: "Flux en direct (admin)",
    de: "Live-Feed (Admin)",
    zh: "实时画面（管理员）",
    it: "Feed in diretta (admin)",
    ru: "Прямой эфир (админ)",
  },
  live_admin_url: {
    es: "URL del stream / video",
    en: "Live stream / video URL",
    fr: "URL du flux / vidéo",
    de: "Livestream- / Video-URL",
    zh: "直播 / 视频链接",
    it: "URL stream / video",
    ru: "URL трансляции / видео",
  },
  live_admin_url_ph: {
    es: "Pega un enlace de YouTube, Vimeo, Twitch o .mp4",
    en: "Paste a YouTube, Vimeo, Twitch or .mp4 link",
    fr: "Collez un lien YouTube, Vimeo, Twitch ou .mp4",
    de: "YouTube-, Vimeo-, Twitch- oder .mp4-Link einfügen",
    zh: "粘贴 YouTube、Vimeo、Twitch 或 .mp4 链接",
    it: "Incolla un link YouTube, Vimeo, Twitch o .mp4",
    ru: "Вставьте ссылку YouTube, Vimeo, Twitch или .mp4",
  },
  live_admin_caption: {
    es: "Descripción (opcional)",
    en: "Caption (optional)",
    fr: "Légende (facultatif)",
    de: "Beschriftung (optional)",
    zh: "说明（可选）",
    it: "Didascalia (facoltativa)",
    ru: "Подпись (необязательно)",
  },
  live_admin_set: {
    es: "Poner stream en vivo",
    en: "Set live stream",
    fr: "Définir le direct",
    de: "Livestream setzen",
    zh: "设置直播",
    it: "Imposta diretta",
    ru: "Задать трансляцию",
  },
  live_admin_upload: {
    es: "Subir clip de video",
    en: "Upload video clip",
    fr: "Téléverser une vidéo",
    de: "Videoclip hochladen",
    zh: "上传视频片段",
    it: "Carica clip video",
    ru: "Загрузить видео",
  },
  live_admin_uploading: {
    es: "Subiendo…",
    en: "Uploading…",
    fr: "Téléversement…",
    de: "Wird hochgeladen…",
    zh: "上传中…",
    it: "Caricamento…",
    ru: "Загрузка…",
  },
  live_admin_clear: {
    es: "Quitar feed",
    en: "Clear feed",
    fr: "Effacer le flux",
    de: "Feed entfernen",
    zh: "清除画面",
    it: "Rimuovi feed",
    ru: "Убрать эфир",
  },
  live_admin_set_ok: {
    es: "Feed en vivo actualizado",
    en: "Live feed updated",
    fr: "Flux en direct mis à jour",
    de: "Live-Feed aktualisiert",
    zh: "实时画面已更新",
    it: "Feed in diretta aggiornato",
    ru: "Прямой эфир обновлён",
  },
  live_admin_err: {
    es: "Algo salió mal",
    en: "Something went wrong",
    fr: "Une erreur s'est produite",
    de: "Etwas ist schiefgelaufen",
    zh: "出了点问题",
    it: "Qualcosa è andato storto",
    ru: "Что-то пошло не так",
  },

  /* Nicaragua Taxi CTA */
  taxi_eyebrow: {
    es: "Partner · Transporte",
    en: "Partner · Transportation",
    fr: "Partenaire · Transport",
    de: "Partner · Transport",
    zh: "合作伙伴 · 交通",
    it: "Partner · Trasporti",
    ru: "Партнёр · Транспорт",
  },
  taxi_headline: {
    es: "¿Necesitas un viaje hacia o desde Popoyo?",
    en: "Need a ride to or from Popoyo?",
    fr: "Besoin d'un trajet vers ou depuis Popoyo ?",
    de: "Brauchst du eine Fahrt nach oder von Popoyo?",
    zh: "需要往返 Popoyo 的接送吗？",
    it: "Ti serve un passaggio da o per Popoyo?",
    ru: "Нужен трансфер в Попойо или из него?",
  },
  taxi_body: {
    es: "Servicios de taxi y traslados seguros y confiables en toda Nicaragua — traslados al aeropuerto, salto de playas, cruces fronterizos y viajes de larga distancia con conductores locales amables.",
    en: "Safe, reliable taxi & shuttle services across Nicaragua — airport transfers, beach hopping, border runs, and long-distance travel with friendly local drivers.",
    fr: "Services de taxi et de navettes fiables et sûrs à travers le Nicaragua — transferts aéroport, plages, frontières et longs trajets avec des chauffeurs locaux sympathiques.",
    de: "Sichere, zuverlässige Taxi- und Shuttle-Services in ganz Nicaragua — Flughafentransfer, Strandhopping, Grenzfahrten und Langstrecken mit freundlichen lokalen Fahrern.",
    zh: "在 Nicaragua 各地提供安全可靠的出租车和班车服务 — 机场接送、海滩游览、边境往返以及由友好的当地司机提供的长途旅行。",
    it: "Servizi taxi e navetta sicuri e affidabili in tutto il Nicaragua — transfer aeroportuali, tour delle spiagge, corse al confine e viaggi a lunga distanza con autisti locali amichevoli.",
    ru: "Безопасные и надёжные услуги такси и шаттлов по всей Nicaragua — трансферы из аэропорта, поездки по пляжам, пересечение границы и дальние поездки с дружелюбными местными водителями.",
  },
  taxi_f1: {
    es: "Traslados al aeropuerto",
    en: "Airport transfers",
    fr: "Transferts aéroport",
    de: "Flughafentransfer",
    zh: "机场接送",
    it: "Trasferimenti aeroportuali",
    ru: "Трансферы в аэропорт",
  },
  taxi_f2: {
    es: "Saltar entre playas",
    en: "Beach hopping",
    fr: "Plages en chaîne",
    de: "Strandhopping",
    zh: "海滩游",
    it: "Tour delle spiagge",
    ru: "Поездки по пляжам",
  },
  taxi_f3: {
    es: "Cruces fronterizos",
    en: "Border crossings",
    fr: "Passages frontaliers",
    de: "Grenzübergänge",
    zh: "过境",
    it: "Attraversamenti di confine",
    ru: "Пересечение границы",
  },
  taxi_f4: {
    es: "Precios honestos",
    en: "Honest pricing",
    fr: "Tarifs honnêtes",
    de: "Faire Preise",
    zh: "诚信定价",
    it: "Prezzi onesti",
    ru: "Честные цены",
  },
  taxi_cta: {
    es: "Reservar en NicaraguaTaxi.com",
    en: "Book now: NicaraguaTaxi.com",
    fr: "Réserver sur NicaraguaTaxi.com",
    de: "Buchen auf NicaraguaTaxi.com",
    zh: "立即预订: NicaraguaTaxi.com",
    it: "Prenota ora: NicaraguaTaxi.com",
    ru: "Забронировать: NicaraguaTaxi.com",
  },
  taxi_caption: {
    es: "Conductores locales · Recogidas puntuales",
    en: "Local drivers · On-time pickups",
    fr: "Chauffeurs locaux · Ponctualité",
    de: "Lokale Fahrer · Pünktlich",
    zh: "本地司机 · 准时接载",
    it: "Autisti locali · Prelievi puntuali",
    ru: "Местные водители · Подача вовремя",
  },

  /* Surf Plans + Friends */
  plans_eyebrow: {
    es: "Tu círculo",
    en: "Your circle",
    fr: "Ton cercle",
    de: "Dein Kreis",
    zh: "你的圈子",
    it: "La tua cerchia",
    ru: "Ваш круг",
  },
  plans_title: {
    es: "Planes de surf y amigos",
    en: "Surf Plans & Friends",
    fr: "Plans de surf & amis",
    de: "Surf-Pläne & Freunde",
    zh: "冲浪计划和朋友",
    it: "Piani Surf & Amici",
    ru: "Сёрф-планы и друзья",
  },
  plans_new: {
    es: "Nuevo plan",
    en: "New plan",
    fr: "Nouveau plan",
    de: "Neuer Plan",
    zh: "新计划",
    it: "Nuovo piano",
    ru: "Новый план",
  },
  plans_login: {
    es: "Inicia sesión para planificar una surfeada",
    en: "Sign in to plan a surf",
    fr: "Connecte-toi pour planifier une session",
    de: "Anmelden um Surf zu planen",
    zh: "登录以计划冲浪",
    it: "Accedi per pianificare un surf",
    ru: "Войдите, чтобы запланировать сёрф",
  },
  plans_tab_plans: {
    es: "Planes",
    en: "Plans",
    fr: "Plans",
    de: "Pläne",
    zh: "计划",
    it: "Piani",
    ru: "Планы",
  },
  plans_tab_friends: {
    es: "Amigos",
    en: "Friends",
    fr: "Amis",
    de: "Freunde",
    zh: "朋友",
    it: "Amici",
    ru: "Друзья",
  },
  plans_yours: {
    es: "Tus planes",
    en: "Your plans",
    fr: "Tes plans",
    de: "Deine Pläne",
    zh: "你的计划",
    it: "I tuoi piani",
    ru: "Ваши планы",
  },
  plans_others: {
    es: "De amigos y comunidad",
    en: "From friends & community",
    fr: "Amis & communauté",
    de: "Von Freunden & Community",
    zh: "来自朋友和社区",
    it: "Da amici e comunità",
    ru: "От друзей и сообщества",
  },
  plans_empty: {
    es: "No hay planes próximos — crea uno y comparte el enlace con amigos.",
    en: "No upcoming plans yet — create one and share the link with friends.",
    fr: "Aucun plan à venir — créez-en un et partagez le lien.",
    de: "Noch keine Pläne — erstelle einen und teile den Link.",
    zh: "尚无即将开始的计划 — 创建一个并与朋友分享链接。",
    it: "Nessun piano imminente — creane uno e condividi il link con gli amici.",
    ru: "Предстоящих планов пока нет — создайте план и поделитесь ссылкой с друзьями.",
  },
  friends_find: {
    es: "Buscar amigos por usuario",
    en: "Find friends by username",
    fr: "Rechercher des amis par nom d'utilisateur",
    de: "Freunde nach Nutzername suchen",
    zh: "按用户名查找朋友",
    it: "Trova amici per nome utente",
    ru: "Найти друзей по имени пользователя",
  },
  friends_incoming: {
    es: "Solicitudes recibidas",
    en: "Incoming requests",
    fr: "Demandes reçues",
    de: "Eingehende Anfragen",
    zh: "收到的请求",
    it: "Richieste in arrivo",
    ru: "Входящие запросы",
  },
  friends_outgoing: {
    es: "Solicitudes enviadas",
    en: "Pending invites you sent",
    fr: "Invitations envoyées",
    de: "Gesendete Anfragen",
    zh: "你已发送的待处理邀请",
    it: "Inviti inviati in sospeso",
    ru: "Отправленные вами приглашения",
  },
  friends_yours: {
    es: "Tus amigos",
    en: "Your friends",
    fr: "Tes amis",
    de: "Deine Freunde",
    zh: "你的朋友",
    it: "I tuoi amici",
    ru: "Ваши друзья",
  },
  friends_none: {
    es: "Aún no tienes amigos. Busca arriba y agrega algunos — luego verán tus planes solo-amigos.",
    en: "No friends yet. Search above and add a few — then they'll see your friends-only surf plans.",
    fr: "Pas encore d'amis. Cherchez ci-dessus pour en ajouter — ils verront vos plans amis-seulement.",
    de: "Noch keine Freunde. Suche oben und füge welche hinzu — dann sehen sie deine Freunde-Pläne.",
    zh: "还没有朋友。在上方搜索并添加一些朋友——然后他们就能看到你仅限朋友的冲浪计划。",
    it: "Nessun amico ancora. Cerca qui sopra e aggiungine alcuni — poi vedranno i tuoi piani di surf solo per amici.",
    ru: "Друзей пока нет. Найдите друзей в поиске выше и добавьте несколько — тогда они увидят ваши планы для сёрфинга, доступные только друзьям.",
  },
  vis_public: {
    es: "Público",
    en: "Public",
    fr: "Public",
    de: "Öffentlich",
    zh: "公开",
    it: "Pubblico",
    ru: "Для всех",
  },
  vis_friends: {
    es: "Solo amigos",
    en: "Friends only",
    fr: "Amis seulement",
    de: "Nur Freunde",
    zh: "仅限朋友",
    it: "Solo amici",
    ru: "Только для друзей",
  },
  vis_link: {
    es: "Solo enlace",
    en: "Link only",
    fr: "Lien uniquement",
    de: "Nur Link",
    zh: "仅限链接",
    it: "Solo con link",
    ru: "Только по ссылке",
  },
  join: {
    es: "Unirse",
    en: "Join",
    fr: "Rejoindre",
    de: "Beitreten",
    zh: "加入",
    it: "Partecipa",
    ru: "Присоединиться",
  },
  leave: {
    es: "Salir",
    en: "Leave",
    fr: "Quitter",
    de: "Verlassen",
    zh: "离开",
    it: "Lascia",
    ru: "Покинуть",
  },
  delete: {
    es: "Eliminar",
    en: "Delete",
    fr: "Supprimer",
    de: "Löschen",
    zh: "删除",
    it: "Elimina",
    ru: "Удалить",
  },

  /* Profile dialog */
  profile_title: {
    es: "Tu perfil",
    en: "Your profile",
    fr: "Ton profil",
    de: "Dein Profil",
    zh: "你的个人资料",
    it: "Il tuo profilo",
    ru: "Ваш профиль",
  },
  profile_photo: {
    es: "Foto de perfil",
    en: "Profile photo",
    fr: "Photo de profil",
    de: "Profilfoto",
    zh: "头像照片",
    it: "Foto del profilo",
    ru: "Фото профиля",
  },
  profile_photo_hint: {
    es: "JPG o PNG · hasta 5 MB. Toca el círculo para subir.",
    en: "JPG or PNG · up to 5 MB. Click the circle to upload.",
    fr: "JPG ou PNG · jusqu'à 5 Mo. Cliquez sur le cercle.",
    de: "JPG oder PNG · bis 5 MB. Auf den Kreis tippen.",
    zh: "JPG 或 PNG · 最大 5 MB。点击圆圈上传。",
    it: "JPG o PNG · fino a 5 MB. Clicca sul cerchio per caricare.",
    ru: "JPG или PNG · до 5 МБ. Нажмите на круг, чтобы загрузить.",
  },
  profile_name: {
    es: "Nombre",
    en: "Name",
    fr: "Nom",
    de: "Name",
    zh: "名称",
    it: "Nome",
    ru: "Имя",
  },
  profile_username: {
    es: "Usuario",
    en: "Username",
    fr: "Nom d'utilisateur",
    de: "Nutzername",
    zh: "用户名",
    it: "Nome utente",
    ru: "Имя пользователя",
  },
  profile_bio: {
    es: "Biografía corta",
    en: "Short bio",
    fr: "Bio courte",
    de: "Kurze Bio",
    zh: "个人简介",
    it: "Breve biografia",
    ru: "Краткая биография",
  },
  profile_bio_ph: {
    es: "Una línea o dos sobre ti — surfista / pescador / dueño de negocio / visitante…",
    en: "A line or two about you — surfer / fisher / business owner / visitor…",
    fr: "Une ou deux lignes sur vous — surfeur / pêcheur / propriétaire / visiteur…",
    de: "Ein paar Worte über dich — Surfer / Fischer / Geschäftsinhaber / Besucher…",
    zh: "关于你的一两句话 — 冲浪者 / 渔民 / 企业主 / 游客…",
    it: "Una riga o due su di te — surfista / pescatore / imprenditore / visitatore…",
    ru: "Пара строк о вас — сёрфер / рыбак / владелец бизнеса / гость…",
  },
  profile_social: {
    es: "Enlaces sociales",
    en: "Social links",
    fr: "Réseaux sociaux",
    de: "Social Links",
    zh: "社交链接",
    it: "Link social",
    ru: "Ссылки на соцсети",
  },
  profile_business: {
    es: "Negocio / Empresa",
    en: "Business / Company",
    fr: "Entreprise",
    de: "Geschäft / Firma",
    zh: "商业 / 公司",
    it: "Attività / Azienda",
    ru: "Бизнес / Компания",
  },
  profile_business_name: {
    es: "Nombre del negocio",
    en: "Business name",
    fr: "Nom de l'entreprise",
    de: "Geschäftsname",
    zh: "企业名称",
    it: "Nome dell'attività",
    ru: "Название компании",
  },
  profile_save: {
    es: "Guardar perfil",
    en: "Save profile",
    fr: "Enregistrer le profil",
    de: "Profil speichern",
    zh: "保存个人资料",
    it: "Salva profilo",
    ru: "Сохранить профиль",
  },

  /* Admin panel */
  admin_tools: {
    es: "Herramientas de administrador",
    en: "Admin tools",
    fr: "Outils d'administrateur",
    de: "Admin-Werkzeuge",
    zh: "管理工具",
    it: "Strumenti admin",
    ru: "Инструменты администратора",
  },
  admin_restricted: {
    es: "Restringido",
    en: "Restricted",
    fr: "Restreint",
    de: "Beschränkt",
    zh: "受限",
    it: "Riservato",
    ru: "Ограниченный доступ",
  },
  admin_roster: {
    es: "Lista de la comunidad — emails y datos de perfil",
    en: "Community roster — emails & profile data",
    fr: "Liste de la communauté — emails & données de profil",
    de: "Community-Liste — E-Mails & Profildaten",
    zh: "社区名册 — 电子邮件和个人资料数据",
    it: "Elenco della comunità — email e dati del profilo",
    ru: "Список сообщества — email и данные профилей",
  },
  admin_filter: {
    es: "Filtrar por email / nombre / usuario",
    en: "Filter by email / name / username",
    fr: "Filtrer par email / nom / utilisateur",
    de: "Nach E-Mail / Name / Nutzer filtern",
    zh: "按电子邮件 / 名称 / 用户名筛选",
    it: "Filtra per email / nome / nome utente",
    ru: "Фильтр по email / имени / имени пользователя",
  },
  admin_load_users: {
    es: "Cargar usuarios",
    en: "Load users",
    fr: "Charger les utilisateurs",
    de: "Nutzer laden",
    zh: "加载用户",
    it: "Carica utenti",
    ru: "Загрузить пользователей",
  },
  admin_export_csv: {
    es: "Exportar CSV",
    en: "Export CSV",
    fr: "Exporter CSV",
    de: "CSV exportieren",
    zh: "导出 CSV",
    it: "Esporta CSV",
    ru: "Экспорт CSV",
  },
  admin_purge_title: {
    es: "Borrar datos de prueba",
    en: "Wipe test data",
    fr: "Effacer les données de test",
    de: "Testdaten löschen",
    zh: "清除测试数据",
    it: "Cancella dati di test",
    ru: "Стереть тестовые данные",
  },
  admin_purge_hint: {
    es: "Úsalo solo para limpiar pruebas — elimina los registros permanentemente.",
    en: "Use these only to clean up testing — they permanently delete records.",
    fr: "À utiliser uniquement pour le nettoyage de tests — supprime définitivement.",
    de: "Nur zum Testaufräumen — löscht Datensätze dauerhaft.",
    zh: "仅用于清理测试 — 它们会永久删除记录。",
    it: "Usare solo per pulire i test — eliminano i record in modo permanente.",
    ru: "Используйте это только для очистки тестовых данных — записи удаляются навсегда.",
  },
  admin_purge_alerts: {
    es: "Todas las alertas/notas",
    en: "All alerts/notes",
    fr: "Toutes les alertes/notes",
    de: "Alle Warnungen/Notizen",
    zh: "所有警报/备注",
    it: "Tutte le allerte/note",
    ru: "Все оповещения/заметки",
  },
  admin_purge_chat: {
    es: "Todos los mensajes de chat",
    en: "All chat messages",
    fr: "Tous les messages",
    de: "Alle Chat-Nachrichten",
    zh: "所有聊天消息",
    it: "Tutti i messaggi chat",
    ru: "Все сообщения чата",
  },
  admin_purge_plans: {
    es: "Todos los planes de surf",
    en: "All surf plans",
    fr: "Tous les plans de surf",
    de: "Alle Surf-Pläne",
    zh: "所有冲浪计划",
    it: "Tutti i piani surf",
    ru: "Все сёрф-планы",
  },
  admin_purge_sessions: {
    es: "Todas las sesiones de surf",
    en: "All surf sessions",
    fr: "Toutes les sessions",
    de: "Alle Surf-Sessions",
    zh: "所有冲浪活动",
    it: "Tutte le sessioni di surf",
    ru: "Все сёрф-сессии",
  },

  /* Footer credit */
  footer_credit: {
    es: "Sitio web creado por",
    en: "Website created by",
    fr: "Site créé par",
    de: "Website erstellt von",
    zh: "网站创建者",
    it: "Sito web creato da",
    ru: "Сайт создан",
  },

  /* Push bell */
  push_alerts_on: {
    es: "Alertas activadas",
    en: "Alerts on",
    fr: "Alertes activées",
    de: "Alarme an",
    zh: "警报已开启",
    it: "Allerte attive",
    ru: "Оповещения вкл.",
  },
  push_alerts: {
    es: "Alertas",
    en: "Alerts",
    fr: "Alertes",
    de: "Alarme",
    zh: "警报",
    it: "Allerte",
    ru: "Оповещения",
  },

  /* Notification preferences */
  notif_title: {
    es: "Notificaciones",
    en: "Notifications",
    fr: "Notifications",
    de: "Benachrichtigungen",
    zh: "通知",
    it: "Notifiche",
    ru: "Уведомления",
  },
  notif_hint: {
    es: "Elige qué te avisamos. Puedes cambiarlo cuando quieras.",
    en: "Choose what you want to be notified about. You can change this anytime.",
    fr: "Choisis ce qui te sera notifié. Modifiable à tout moment.",
    de: "Wähle, worüber du benachrichtigt wirst. Jederzeit änderbar.",
    zh: "选择您想接收通知的内容。您可以随时更改此设置。",
    it: "Scegli di cosa vuoi essere avvisato. Puoi cambiarlo in qualsiasi momento.",
    ru: "Выберите, о чем вы хотите получать уведомления. Вы можете изменить это в любое время.",
  },
  notif_earthquakes: {
    es: "Terremotos cerca de Popoyo",
    en: "Earthquakes near Popoyo",
    fr: "Séismes près de Popoyo",
    de: "Erdbeben in der Nähe von Popoyo",
    zh: "Popoyo 附近的地震",
    it: "Terremoti vicino a Popoyo",
    ru: "Землетрясения рядом с Popoyo",
  },
  notif_storms: {
    es: "Tormentas, huracanes y tsunamis",
    en: "Storms, hurricanes & tsunamis",
    fr: "Tempêtes, ouragans & tsunamis",
    de: "Stürme, Hurrikane & Tsunamis",
    zh: "风暴、飓风和海啸",
    it: "Tempeste, uragani e tsunami",
    ru: "Штормы, ураганы и цунами",
  },
  notif_admin: {
    es: "Avisos del administrador",
    en: "Admin announcements",
    fr: "Annonces de l'administrateur",
    de: "Admin-Ankündigungen",
    zh: "管理员公告",
    it: "Annunci dell'amministratore",
    ru: "Объявления администратора",
  },
  notif_chat: {
    es: "Mensajes de chat comunitario",
    en: "Community chat messages",
    fr: "Messages du chat communautaire",
    de: "Community-Chat-Nachrichten",
    zh: "社区聊天消息",
    it: "Messaggi della chat della comunità",
    ru: "Сообщения в чате сообщества",
  },
  notif_daily_surf: {
    es: "Reporte diario de surf (8:00 AM)",
    en: "Daily surf report (8:00 AM)",
    fr: "Rapport de surf quotidien (8h00)",
    de: "Tägliche Surf-Meldung (8:00 Uhr)",
    zh: "每日冲浪报告（早上8点）",
    it: "Report quotidiano del surf (ore 8:00)",
    ru: "Ежедневный отчёт о сёрфинге (8:00)",
  },
  footer_data: {
    es: "Datos",
    en: "Data",
    fr: "Données",
    de: "Daten",
    zh: "数据",
    it: "Dati",
    ru: "Данные",
  },
  footer_disclaimer: {
    es: "Aviso",
    en: "Disclaimer",
    fr: "Avertissement",
    de: "Hinweis",
    zh: "免责声明",
    it: "Disclaimer",
    ru: "Отказ от ответственности",
  },
  footer_location: {
    es: "Popoyo, Nicaragua · Costa Pacífica",
    en: "Popoyo, Nicaragua · Pacific Coast",
    fr: "Popoyo, Nicaragua · Côte Pacifique",
    de: "Popoyo, Nicaragua · Pazifikküste",
    zh: "机场接送",
    it: "Popoyo, Nicaragua · Costa del Pacifico",
    ru: "Трансферы из аэропорта",
  },
  data_openmeteo: {
    es: "Open-Meteo (surf, clima)",
    en: "Open-Meteo (surf, weather)",
    fr: "Open-Meteo (surf, météo)",
    de: "Open-Meteo (Surf, Wetter)",
    zh: "Open-Meteo (冲浪、天气)",
    it: "Open-Meteo (surf, meteo)",
    ru: "Open-Meteo (сёрфинг, погода)",
  },
  data_usgs: {
    es: "USGS (sismos)",
    en: "USGS (earthquakes)",
    fr: "USGS (séismes)",
    de: "USGS (Erdbeben)",
    zh: "USGS (地震)",
    it: "USGS (terremoti)",
    ru: "USGS (землетрясения)",
  },
  data_noaa: {
    es: "NOAA NTWC (tsunami)",
    en: "NOAA NTWC (tsunami)",
    fr: "NOAA NTWC (tsunami)",
    de: "NOAA NTWC (Tsunami)",
    zh: "NOAA NTWC (海啸)",
    it: "NOAA NTWC (tsunami)",
    ru: "NOAA NTWC (цунами)",
  },
  data_ineter: {
    es: "INETER / SINAPRED (Nicaragua)",
    en: "INETER / SINAPRED (Nicaragua)",
    fr: "INETER / SINAPRED (Nicaragua)",
    de: "INETER / SINAPRED (Nicaragua)",
    zh: "INETER / SINAPRED (Nicaragua)",
    it: "INETER / SINAPRED (Nicaragua)",
    ru: "INETER / SINAPRED (Nicaragua)",
  },
  select_beach: {
    es: "Elige una playa",
    en: "Select a beach",
    fr: "Choisir une plage",
    de: "Strand wählen",
    zh: "选择一个海滩",
    it: "Seleziona una spiaggia",
    ru: "Выберите пляж",
  },
  no_quakes_msg: {
    es: "Sin sismos M5+ en 40 km en los últimos 30 días. 🤙",
    en: "No M5+ earthquakes within 25 miles in the last 30 days. 🤙",
    fr: "Aucun séisme M5+ dans un rayon de 40 km au cours des 30 derniers jours. 🤙",
    de: "Keine M5+ Erdbeben im Umkreis von 40 km in den letzten 30 Tagen. 🤙",
    zh: "Open-Meteo (冲浪, 天气)",
    it: "Open-Meteo (surf, meteo)",
    ru: "Open-Meteo (сёрфинг, погода)",
  },
  delete_alert_confirm: {
    es: "¿Eliminar esta alerta?",
    en: "Delete this alert?",
    fr: "Supprimer cette alerte ?",
    de: "Diese Warnung löschen?",
    zh: "删除此警报？",
    it: "Eliminare questa allerta?",
    ru: "Удалить это оповещение?",
  },
  admin_label: {
    es: "Admin",
    en: "Admin",
    fr: "Admin",
    de: "Admin",
    zh: "管理员",
    it: "Admin",
    ru: "Админ",
  },
  live_label: {
    es: "en vivo",
    en: "live",
    fr: "en direct",
    de: "live",
    zh: "直播",
    it: "in diretta",
    ru: "в эфире",
  },
  updating_label: {
    es: "actualizando",
    en: "updating",
    fr: "mise à jour",
    de: "wird aktualisiert",
    zh: "更新中",
    it: "aggiornamento",
    ru: "обновление",
  },
  chat_empty: {
    es: "🌊 Saluda para empezar la conversación.",
    en: "🌊 Say aloha to start the conversation.",
    fr: "🌊 Dites bonjour pour démarrer la conversation.",
    de: "🌊 Sag Hallo, um das Gespräch zu starten.",
    zh: "删除此警报？",
    it: "Eliminare questo avviso?",
    ru: "Удалить это оповещение?",
  },
  uploading: {
    es: "Subiendo…",
    en: "Uploading…",
    fr: "Téléchargement…",
    de: "Wird hochgeladen…",
    zh: "上传中…",
    it: "Caricamento…",
    ru: "Загрузка…",
  },
  ready_to_send: {
    es: "Listo para enviar",
    en: "Ready to send",
    fr: "Prêt à envoyer",
    de: "Bereit zum Senden",
    zh: "准备发送",
    it: "Pronto per l'invio",
    ru: "Готово к отправке",
  },
  upload_failed: {
    es: "Error al subir la imagen",
    en: "Image upload failed",
    fr: "Échec de l'envoi",
    de: "Bild-Upload fehlgeschlagen",
    zh: "图片上传失败",
    it: "Caricamento immagine non riuscito",
    ru: "Не удалось загрузить изображение",
  },
  surf_unavailable: {
    es: "Pronóstico de surf no disponible. Intenta en unos minutos.",
    en: "Surf forecast temporarily unavailable. Try again in a few minutes.",
    fr: "Prévisions surf indisponibles. Réessayez dans quelques minutes.",
    de: "Surf-Vorhersage vorübergehend nicht verfügbar. Bitte in einigen Minuten erneut versuchen.",
    zh: "上传中…",
    it: "Caricamento in corso…",
    ru: "Загрузка…",
  },
  weather_unavailable: {
    es: "Datos de clima no disponibles. Surf, mareas y luna siguen en vivo.",
    en: "Weather data temporarily unavailable. Surf, tide and moon data still live.",
    fr: "Données météo indisponibles. Surf, marée et lune restent en direct.",
    de: "Wetterdaten nicht verfügbar. Surf-, Gezeiten- und Monddaten weiter live.",
    zh: "天气数据暂时不可用。冲浪、潮汐和月相数据仍然有效。",
    it: "Dati meteo temporaneamente non disponibili. I dati su surf, maree e luna sono ancora attivi.",
    ru: "Данные о погоде временно недоступны. Данные о сёрфинге, приливах и луне по-прежнему доступны.",
  },
  peak: {
    es: "Pico",
    en: "Peak",
    fr: "Pic",
    de: "Spitze",
    zh: "峰值",
    it: "Picco",
    ru: "Пик",
  },
  wind_label: {
    es: "viento",
    en: "wind",
    fr: "vent",
    de: "Wind",
    zh: "风",
    it: "vento",
    ru: "ветер",
  },
  beach_note_placeholder: {
    es: "ej. Resaca fuerte en marea alta — surfea la esquina norte.",
    en: "e.g. Strong south rip at high tide — surf the north corner.",
    fr: "ex. Courant fort à marée haute — surfez le coin nord.",
    de: "z.B. Starke Strömung bei Hochwasser — surfe die Nord-Ecke.",
    zh: "峰值",
    it: "Picco",
    ru: "Пик",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
    fr: "Annuler",
    de: "Abbrechen",
    zh: "取消",
    it: "Annulla",
    ru: "Отмена",
  },
  auth_welcome_back: {
    es: "Bienvenido de vuelta a la comunidad Popoyo.",
    en: "Welcome back to the Popoyo community.",
    fr: "Bienvenue dans la communauté Popoyo.",
    de: "Willkommen zurück in der Popoyo-Community.",
    zh: "取消",
    it: "Annulla",
    ru: "Отмена",
  },
  auth_create_account: {
    es: "Crea una cuenta gratis para unirte al chat en vivo.",
    en: "Create a free account to join the live community chat.",
    fr: "Créez un compte gratuit pour rejoindre le chat en direct.",
    de: "Erstelle ein kostenloses Konto, um am Live-Chat teilzunehmen.",
    zh: "创建一个免费帐户以加入实时社区聊天。",
    it: "Crea un account gratuito per unirti alla chat della community dal vivo.",
    ru: "Создайте бесплатную учётную запись, чтобы присоединиться к живому чату сообщества.",
  },
  wcond_0: {
    es: "Despejado",
    en: "Clear",
    fr: "Dégagé",
    de: "Klar",
    zh: "晴",
    it: "Sereno",
    ru: "Ясно",
  },
  wcond_1: {
    es: "Mayormente despejado",
    en: "Mostly clear",
    fr: "Plutôt clair",
    de: "Überwiegend klar",
    zh: "大部晴朗",
    it: "Prevalentemente sereno",
    ru: "В основном ясно",
  },
  wcond_2: {
    es: "Parcialmente nublado",
    en: "Partly cloudy",
    fr: "Partiellement nuageux",
    de: "Teilweise bewölkt",
    zh: "多云",
    it: "Parzialmente nuvoloso",
    ru: "Переменная облачность",
  },
  wcond_3: {
    es: "Nublado",
    en: "Overcast",
    fr: "Couvert",
    de: "Bedeckt",
    zh: "阴",
    it: "Coperto",
    ru: "Пасмурно",
  },
  wcond_45: {
    es: "Niebla",
    en: "Fog",
    fr: "Brouillard",
    de: "Nebel",
    zh: "雾",
    it: "Nebbia",
    ru: "Туман",
  },
  wcond_51: {
    es: "Llovizna ligera",
    en: "Light drizzle",
    fr: "Bruine légère",
    de: "Leichter Nieselregen",
    zh: "小毛毛雨",
    it: "Pioviggine leggera",
    ru: "Лёгкая морось",
  },
  wcond_53: {
    es: "Llovizna",
    en: "Drizzle",
    fr: "Bruine",
    de: "Nieselregen",
    zh: "毛毛雨",
    it: "Pioviggine",
    ru: "Морось",
  },
  wcond_55: {
    es: "Llovizna fuerte",
    en: "Heavy drizzle",
    fr: "Bruine forte",
    de: "Starker Nieselregen",
    zh: "大毛毛雨",
    it: "Pioviggine forte",
    ru: "Сильная морось",
  },
  wcond_61: {
    es: "Lluvia ligera",
    en: "Light rain",
    fr: "Pluie légère",
    de: "Leichter Regen",
    zh: "小雨",
    it: "Pioggia debole",
    ru: "Небольшой дождь",
  },
  wcond_63: {
    es: "Lluvia",
    en: "Rain",
    fr: "Pluie",
    de: "Regen",
    zh: "雨",
    it: "Pioggia",
    ru: "Дождь",
  },
  wcond_65: {
    es: "Lluvia fuerte",
    en: "Heavy rain",
    fr: "Pluie forte",
    de: "Starker Regen",
    zh: "大雨",
    it: "Pioggia forte",
    ru: "Сильный дождь",
  },
  wcond_71: {
    es: "Nieve",
    en: "Snow",
    fr: "Neige",
    de: "Schnee",
    zh: "雪",
    it: "Neve",
    ru: "Снег",
  },
  wcond_80: {
    es: "Chubascos",
    en: "Showers",
    fr: "Averses",
    de: "Schauer",
    zh: "阵雨",
    it: "Rovescio",
    ru: "Ливень",
  },
  wcond_82: {
    es: "Chubascos fuertes",
    en: "Heavy showers",
    fr: "Fortes averses",
    de: "Starke Schauer",
    zh: "大阵雨",
    it: "Forti rovesci",
    ru: "Сильный ливень",
  },
  wcond_95: {
    es: "Tormenta eléctrica",
    en: "Thunderstorm",
    fr: "Orage",
    de: "Gewitter",
    zh: "雷暴",
    it: "Temporale",
    ru: "Гроза",
  },
  best_window: {
    es: "Mejor ventana de surf",
    en: "Best surf window",
    fr: "Meilleure fenêtre",
    de: "Beste Surf-Zeit",
    zh: "最佳冲浪时段",
    it: "Miglior finestra per il surf",
    ru: "Лучшее время для сёрфинга",
  },
  beach_notes: {
    es: "Notas del admin",
    en: "Beach notes from admin",
    fr: "Notes de l'admin",
    de: "Admin-Notizen",
    zh: "来自管理员的海滩备注",
    it: "Note sulla spiaggia dall'admin",
    ru: "Заметки о пляже от администратора",
  },
  save: {
    es: "Guardar",
    en: "Save",
    fr: "Enregistrer",
    de: "Speichern",
    zh: "保存",
    it: "Salva",
    ru: "Сохранить",
  },
  edit: {
    es: "Editar",
    en: "Edit",
    fr: "Éditer",
    de: "Bearbeiten",
    zh: "编辑",
    it: "Modifica",
    ru: "Править",
  },
  no_notes_yet: {
    es: "Aún no hay notas.",
    en: "No notes yet.",
    fr: "Pas encore de notes.",
    de: "Noch keine Notizen.",
    zh: "暂无备注。",
    it: "Nessuna nota ancora.",
    ru: "Заметок пока нет.",
  },
  estimated_tides: {
    es: "Mareas estimadas (no oficial)",
    en: "Estimated tides (not official)",
    fr: "Marées estimées (non officielles)",
    de: "Geschätzte Gezeiten (nicht offiziell)",
    zh: "预估潮汐 (非官方)",
    it: "Maree stimate (non ufficiali)",
    ru: "Примерные приливы (неофициально)",
  },
  saved_to_phone: {
    es: "¿Guardarla en tu teléfono?",
    en: "Save it to your phone?",
    fr: "Enregistrer sur votre téléphone ?",
    de: "Auf dem Telefon speichern?",
    zh: "保存到您的手机？",
    it: "Salvarla sul tuo telefono?",
    ru: "Сохранить на телефон?",
  },
  install_hint: {
    es: "En iPhone: Compartir → Añadir a la pantalla de inicio.",
    en: "On iPhone: Share → Add to Home Screen.",
    fr: "Sur iPhone : Partager → Sur l'écran d'accueil.",
    de: "Auf dem iPhone: Teilen → Zum Home-Bildschirm.",
    zh: "晴朗",
    it: "Su iPhone: Condividi → Aggiungi a schermata Home.",
    ru: "Ясно",
  },

  /* --- Suggestions section ----------------------------------------- */
  sug_eyebrow: { es: "Comunidad · Sugerencias", en: "Community · Suggestions", fr: "Communauté · Suggestions", de: "Community · Vorschläge", zh: "社区 · 建议", it: "Comunità · Suggerimenti", ru: "Сообщество · Предложения" },
  sug_title: { es: "¿Qué quieres ver en Popoyo.app?", en: "What do you want to see on Popoyo.app?", fr: "Que voulez-vous voir sur Popoyo.app ?", de: "Was möchtest du auf Popoyo.app sehen?", zh: "您希望在 Popoyo.app 上看到什么？", it: "Cosa vorresti vedere su Popoyo.app?", ru: "Что вы хотите видеть на Popoyo.app?" },
  sug_subtitle: {
    es: "Ofertas de empleo, compra y venta, eventos mensuales, recaudaciones y más — comparte tu idea y el equipo de Popoyo la revisará.",
    en: "Now-hiring boards, buy & sell, monthly events, fundraisers, and more — share your idea and the Popoyo team will review it.",
    fr: "Offres d'emploi, achat et vente, événements mensuels, collectes de fonds, et plus — partagez votre idée, l'équipe Popoyo l'examinera.",
    de: "Stellenangebote, Kaufen und Verkaufen, monatliche Events, Spendenaktionen und mehr — teile deine Idee und das Popoyo-Team prüft sie.",
    zh: "招聘信息、二手买卖、每月活动、募款等等——分享你的想法，Popoyo 团队会进行审核。",
    it: "Annunci di lavoro, compra-vendita, eventi mensili, raccolte fondi e altro — condividi la tua idea e il team Popoyo la esaminerà.",
    ru: "Объявления о работе, купля-продажа, ежемесячные мероприятия, сборы средств и многое другое — поделитесь идеей, команда Popoyo её рассмотрит.",
  },
  sug_cat_hiring: { es: "Empleo", en: "Now hiring", fr: "Emplois", de: "Stellenangebote", zh: "招聘", it: "Lavoro", ru: "Вакансии" },
  sug_cat_buy_sell: { es: "Compra/Venta", en: "Buy & sell", fr: "Achat & vente", de: "Kaufen & verkaufen", zh: "买卖", it: "Compra & vendi", ru: "Купля/продажа" },
  sug_cat_events: { es: "Eventos", en: "Events", fr: "Événements", de: "Veranstaltungen", zh: "活动", it: "Eventi", ru: "Мероприятия" },
  sug_cat_fundraisers: { es: "Recaudaciones", en: "Fundraisers", fr: "Collectes", de: "Spendenaktionen", zh: "募款", it: "Raccolte fondi", ru: "Сбор средств" },
  sug_cat_other: { es: "Otro", en: "Other", fr: "Autre", de: "Sonstiges", zh: "其他", it: "Altro", ru: "Другое" },
  sug_title_placeholder: { es: "Título corto de tu idea", en: "Short title for your idea", fr: "Titre court de votre idée", de: "Kurzer Titel deiner Idee", zh: "想法的简短标题", it: "Titolo breve della tua idea", ru: "Краткое название вашей идеи" },
  sug_body_placeholder: {
    es: "Cuéntanos más — ¿qué resolvería? ¿quién la usaría?",
    en: "Tell us more — what would it solve? who would use it?",
    fr: "Dites-nous en plus — que résoudrait-elle ? qui l'utiliserait ?",
    de: "Erzähl uns mehr — was würde es lösen? wer würde es nutzen?",
    zh: "详细说明——它能解决什么问题？谁会使用它？",
    it: "Raccontaci di più — cosa risolverebbe? chi la userebbe?",
    ru: "Расскажите подробнее — что это решит? кто будет пользоваться?",
  },
  sug_submit: { es: "Enviar idea", en: "Send idea", fr: "Envoyer", de: "Idee senden", zh: "提交想法", it: "Invia idea", ru: "Отправить идею" },
  sug_signed_as: { es: "Como", en: "As", fr: "En tant que", de: "Als", zh: "身份：", it: "Come", ru: "От имени" },
  sug_thanks: { es: "¡Gracias! El admin recibirá tu sugerencia.", en: "Thanks! The admin will receive your suggestion.", fr: "Merci ! L'admin recevra votre suggestion.", de: "Danke! Der Admin erhält deinen Vorschlag.", zh: "感谢您的建议！管理员会查看。", it: "Grazie! L'admin riceverà il tuo suggerimento.", ru: "Спасибо! Администратор получит ваше предложение." },
  sug_validation: { es: "Título ≥ 3 caracteres y descripción ≥ 10.", en: "Title needs 3+ chars and description 10+.", fr: "Titre ≥ 3 caractères et description ≥ 10.", de: "Titel ≥ 3 Zeichen und Beschreibung ≥ 10.", zh: "标题至少3个字符，描述至少10个。", it: "Titolo ≥ 3 caratteri e descrizione ≥ 10.", ru: "Заголовок ≥ 3 символов и описание ≥ 10." },
  sug_login_prompt: {
    es: "Crea una cuenta gratuita o inicia sesión para enviar tus ideas al equipo.",
    en: "Create a free account or sign in to send your ideas to the team.",
    fr: "Créez un compte gratuit ou connectez-vous pour envoyer vos idées à l'équipe.",
    de: "Erstelle ein kostenloses Konto oder melde dich an, um Ideen ans Team zu senden.",
    zh: "创建免费账户或登录，把您的想法发送给团队。",
    it: "Crea un account gratuito o accedi per inviare le tue idee al team.",
    ru: "Создайте бесплатный аккаунт или войдите, чтобы отправить идеи команде.",
  },
  sug_mine_title: { es: "Mis sugerencias", en: "My suggestions", fr: "Mes suggestions", de: "Meine Vorschläge", zh: "我的建议", it: "I miei suggerimenti", ru: "Мои предложения" },
  sug_admin_reply: { es: "Respuesta admin", en: "Admin reply", fr: "Réponse admin", de: "Admin-Antwort", zh: "管理员回复", it: "Risposta admin", ru: "Ответ админа" },
  sug_status_new: { es: "Nuevo", en: "New", fr: "Nouveau", de: "Neu", zh: "新", it: "Nuovo", ru: "Новое" },
  sug_status_planned: { es: "Planificado", en: "Planned", fr: "Planifié", de: "Geplant", zh: "已计划", it: "Pianificato", ru: "Запланировано" },
  sug_status_in_progress: { es: "En progreso", en: "In progress", fr: "En cours", de: "In Bearbeitung", zh: "进行中", it: "In corso", ru: "В работе" },
  sug_status_done: { es: "Hecho", en: "Done", fr: "Terminé", de: "Erledigt", zh: "已完成", it: "Fatto", ru: "Готово" },
  sug_status_rejected: { es: "Rechazado", en: "Rejected", fr: "Rejeté", de: "Abgelehnt", zh: "已拒绝", it: "Rifiutato", ru: "Отклонено" },

  /* --- Local Partners section ------------------------------------- */
  partners_eyebrow: { es: "Aliados locales · Popoyo", en: "Local partners · Popoyo", fr: "Partenaires locaux · Popoyo", de: "Lokale Partner · Popoyo", zh: "本地合作伙伴 · Popoyo", it: "Partner locali · Popoyo", ru: "Локальные партнёры · Popoyo" },
  partners_title: { es: "¡Aliados locales de Popoyo!", en: "Local Popoyo Partners!", fr: "Partenaires locaux de Popoyo !", de: "Lokale Partner aus Popoyo!", zh: "圣胡安德尔苏尔本地合作伙伴！", it: "Partner locali di Popoyo!", ru: "Местные партнёры в Сан-Хуан-дель-Сур!" },
  partners_subtitle: {
    es: "Negocios y creadores de Popoyo que apoyamos con orgullo. Haz clic en cualquiera para visitar su sitio.",
    en: "Businesses and creators in Popoyo we proudly support. Tap any card to visit their site.",
    fr: "Entreprises et créateurs de Popoyo que nous soutenons avec fierté. Cliquez sur n'importe quelle carte pour visiter leur site.",
    de: "Unternehmen und Kreative aus Popoyo, die wir mit Stolz unterstützen. Klicke auf eine Karte, um die Seite zu besuchen.",
    zh: "我们引以为豪支持的 Popoyo 当地企业与创作者。点击任意卡片即可访问他们的网站。",
    it: "Attività e creatori di Popoyo che sosteniamo con orgoglio. Tocca una carta per visitare il sito.",
    ru: "Бизнесы и создатели в Popoyo, которых мы с гордостью поддерживаем. Нажмите на любую карточку, чтобы перейти на сайт.",
  },
  partners_cta_eyebrow: { es: "Diseño web · Nicaragua", en: "Web design · Nicaragua", fr: "Conception web · Nicaragua", de: "Webdesign · Nicaragua", zh: "网站设计 · 尼加拉瓜", it: "Web design · Nicaragua", ru: "Веб-дизайн · Никарагуа" },
  partners_cta_title: {
    es: "¿Buscas un sitio web increíble en Nicaragua?",
    en: "Looking for an incredible website in Nicaragua?",
    fr: "Vous cherchez un site web incroyable au Nicaragua ?",
    de: "Du suchst eine großartige Website in Nicaragua?",
    zh: "想要在尼加拉瓜拥有一个出色的网站吗？",
    it: "Cerchi un sito web straordinario in Nicaragua?",
    ru: "Ищете потрясающий сайт в Никарагуа?",
  },
  partners_cta_subtitle: {
    es: "Contacta a Greg Miceli — diseñador de cada uno de los sitios listados arriba.",
    en: "Reach out to Greg Miceli — designer of every site listed above.",
    fr: "Contactez Greg Miceli — concepteur de chaque site répertorié ci-dessus.",
    de: "Wende dich an Greg Miceli — Designer aller oben aufgeführten Seiten.",
    zh: "联系 Greg Miceli——以上所有网站的设计师。",
    it: "Contatta Greg Miceli — designer di tutti i siti elencati sopra.",
    ru: "Напишите Greg Miceli — дизайнеру всех перечисленных выше сайтов.",
  },
  partners_cta_button: { es: "Chatear por WhatsApp", en: "Chat on WhatsApp", fr: "Discuter sur WhatsApp", de: "Auf WhatsApp chatten", zh: "WhatsApp 联系", it: "Chatta su WhatsApp", ru: "Написать в WhatsApp" },

  nav_live: { es: "Cámara en vivo", en: "Live Cam", fr: "Caméra en direct", de: "Live-Cam", zh: "实时直播", it: "Cam in diretta", ru: "Веб-камера" },
  footer_sister: { es: "Sitio hermano", en: "Sister site", fr: "Site jumeau", de: "Schwesterseite", zh: "姊妹站点", it: "Sito gemello", ru: "Родственный сайт" },

  livecam_h1: {
    es: "Cámara de Surf en Vivo de Popoyo",
    en: "Popoyo Live Surf Cam",
    fr: "Webcam de Surf en Direct de Popoyo",
    de: "Popoyo Live-Surf-Cam",
    zh: "波波约实时冲浪直播",
    it: "Webcam Surf in Diretta di Popoyo",
    ru: "Прямая сёрф-камера Попойо",
  },
  livecam_tagline: {
    es: "El único stream de surf en vivo de Popoyo y Tola, Nicaragua",
    en: "The only live surf stream for Popoyo & Tola, Nicaragua",
    fr: "Le seul stream de surf en direct pour Popoyo et Tola, Nicaragua",
    de: "Der einzige Live-Surf-Stream für Popoyo & Tola, Nicaragua",
    zh: "尼加拉瓜波波约与托拉唯一的实时冲浪直播",
    it: "L'unico stream di surf in diretta per Popoyo e Tola, Nicaragua",
    ru: "Единственная прямая сёрф-трансляция Попойо и Толы, Никарагуа",
  },
  livecam_intro: {
    es: "Mira las olas de Popoyo en tiempo real. Esta es la única cámara de surf en vivo transmitiendo en línea para la costa de Popoyo–Tola — revisa el swell, el viento y la cantidad de gente antes de entrar al agua, desde cualquier parte del mundo.",
    en: "Watch the waves at Popoyo in real time. This is the only live surf camera streaming online for the Popoyo–Tola coast — check the swell, wind and crowd before you paddle out, from anywhere in the world.",
    fr: "Regardez les vagues de Popoyo en temps réel. C'est la seule caméra de surf en direct diffusée en ligne pour la côte de Popoyo–Tola — vérifiez la houle, le vent et l'affluence avant de vous mettre à l'eau, où que vous soyez.",
    de: "Beobachte die Wellen von Popoyo in Echtzeit. Dies ist die einzige online übertragene Live-Surf-Kamera für die Küste von Popoyo–Tola — prüfe Swell, Wind und Andrang, bevor du rauspaddelst, von überall auf der Welt.",
    zh: "实时观看波波约的海浪。这是波波约–托拉海岸唯一在线播出的实时冲浪摄像头——出发下水前，随时随地查看涌浪、风况与人流。",
    it: "Guarda le onde di Popoyo in tempo reale. Questa è l'unica webcam di surf in diretta trasmessa online per la costa di Popoyo–Tola — controlla swell, vento e affollamento prima di entrare in acqua, da qualsiasi parte del mondo.",
    ru: "Смотрите волны Попойо в реальном времени. Это единственная прямая сёрф-камера, вещающая онлайн для побережья Попойо–Тола — проверьте свелл, ветер и загруженность перед выходом на воду, откуда угодно.",
  },
  livecam_about_h: {
    es: "Sobre la cámara en vivo", en: "About the live cam", fr: "À propos de la caméra en direct", de: "Über die Live-Cam", zh: "关于实时摄像头", it: "Informazioni sulla webcam", ru: "О прямой трансляции",
  },
  livecam_about_p: {
    es: "Nuestro stream en vivo apunta al reef break de Beginner's Bay, Popoyo, en la Costa Esmeralda de Nicaragua. Funciona durante las horas de luz y muestra las condiciones actuales — ideal para surfistas que planean una sesión, viajeros soñando con un viaje o locales revisando el line-up.",
    en: "Our live stream points at the reef break at Beginner's Bay, Popoyo, on Nicaragua's Emerald Coast (Costa Esmeralda). It runs during daylight hours and shows current conditions — perfect for surfers planning a session, travelers dreaming of a trip, or locals checking the lineup.",
    fr: "Notre stream en direct pointe sur le reef break de Beginner's Bay, Popoyo, sur la Côte d'Émeraude du Nicaragua (Costa Esmeralda). Il fonctionne en journée et montre les conditions actuelles — parfait pour les surfeurs qui planifient une session, les voyageurs qui rêvent d'un séjour ou les locaux qui vérifient le line-up.",
    de: "Unser Live-Stream zeigt den Riffbruch an der Beginner's Bay, Popoyo, an Nicaraguas Smaragdküste (Costa Esmeralda). Er läuft bei Tageslicht und zeigt die aktuellen Bedingungen — perfekt für Surfer, die eine Session planen, Reisende, die von einem Trip träumen, oder Einheimische, die das Line-up checken.",
    zh: "我们的实时直播对准尼加拉瓜翡翠海岸（Costa Esmeralda）波波约 Beginner's Bay 的礁石浪点。它在白天运行，展示当前海况——非常适合计划下水的冲浪者、憧憬旅行的旅人，或查看浪区人流的本地人。",
    it: "Il nostro stream in diretta inquadra il reef break di Beginner's Bay, Popoyo, sulla Costa Smeralda del Nicaragua (Costa Esmeralda). È attivo durante le ore diurne e mostra le condizioni attuali — perfetto per i surfisti che pianificano una sessione, i viaggiatori che sognano un viaggio o i local che controllano il line-up.",
    ru: "Наша прямая трансляция направлена на рифовый брейк в Beginner's Bay, Попойо, на Изумрудном берегу Никарагуа (Costa Esmeralda). Она работает в светлое время суток и показывает текущие условия — идеально для сёрферов, планирующих сессию, путешественников, мечтающих о поездке, или местных, проверяющих лайнап.",
  },
  livecam_where_h: {
    es: "¿Dónde está la cámara?", en: "Where is the camera?", fr: "Où se trouve la caméra ?", de: "Wo steht die Kamera?", zh: "摄像头在哪里？", it: "Dov'è la webcam?", ru: "Где находится камера?",
  },
  livecam_where_p: {
    es: "La cámara da a Playa Popoyo, en el municipio de Tola, Rivas — hogar de uno de los reef breaks tipo A-frame más consistentes de Centroamérica, peinado casi todo el año por los vientos offshore del cercano Lago de Nicaragua.",
    en: "The camera overlooks Playa Popoyo in the municipality of Tola, Rivas — home to one of Central America's most consistent A-frame reef breaks, groomed almost year-round by offshore winds off nearby Lake Nicaragua.",
    fr: "La caméra surplombe Playa Popoyo, dans la municipalité de Tola, Rivas — l'un des reef breaks en A-frame les plus réguliers d'Amérique centrale, lissé presque toute l'année par les vents offshore du lac Nicaragua voisin.",
    de: "Die Kamera blickt auf Playa Popoyo in der Gemeinde Tola, Rivas — Heimat eines der beständigsten A-Frame-Riffbrüche Mittelamerikas, fast ganzjährig geglättet von den ablandigen Winden des nahen Nicaraguasees.",
    zh: "摄像头俯瞰里瓦斯省托拉市的 Playa Popoyo——这里拥有中美洲最稳定的 A 字形礁石浪之一，几乎全年都被邻近尼加拉瓜湖的离岸风梳理得干净利落。",
    it: "La webcam si affaccia su Playa Popoyo, nel comune di Tola, Rivas — sede di uno dei reef break ad A-frame più costanti dell'America Centrale, pettinato quasi tutto l'anno dai venti offshore del vicino Lago Nicaragua.",
    ru: "Камера выходит на Плайя-Попойо в муниципалитете Тола, Ривас — здесь один из самых стабильных A-образных рифовых брейков Центральной Америки, почти круглый год выглаживаемый береговыми ветрами с озера Никарагуа.",
  },
  livecam_best_h: {
    es: "Mejor momento para mirar", en: "Best time to watch", fr: "Meilleur moment pour regarder", de: "Beste Zeit zum Zuschauen", zh: "最佳观看时间", it: "Momento migliore per guardare", ru: "Лучшее время для просмотра",
  },
  livecam_best_p: {
    es: "Popoyo funciona en casi todas las mareas, pero suele estar mejor alrededor de la media marea con un swell sólido. El amanecer y el final de la tarde ofrecen normalmente las condiciones más limpias y la mejor luz en la cámara.",
    en: "Popoyo works on most tides but is often best around mid-tide with a solid swell. Dawn and late afternoon typically offer the cleanest conditions and the best light on the cam.",
    fr: "Popoyo marche à presque toutes les marées, mais est souvent meilleur autour de la mi-marée avec une houle solide. L'aube et la fin d'après-midi offrent généralement les conditions les plus propres et la meilleure lumière sur la caméra.",
    de: "Popoyo funktioniert bei den meisten Gezeiten, ist aber oft um die Halbtide mit solidem Swell am besten. Morgengrauen und später Nachmittag bieten meist die saubersten Bedingungen und das beste Licht auf der Cam.",
    zh: "波波约在大多数潮位都能成浪，但通常在半潮加上稳定涌浪时最佳。黎明和傍晚往往提供最干净的海况以及镜头下最好的光线。",
    it: "Popoyo funziona con quasi tutte le maree, ma è spesso al meglio intorno alla mezza marea con uno swell solido. All'alba e nel tardo pomeriggio si hanno di solito le condizioni più pulite e la luce migliore sulla cam.",
    ru: "Попойо работает почти на всех приливах, но часто лучше всего в районе среднего прилива при хорошем свелле. Рассвет и поздний день обычно дают самые чистые условия и лучший свет на камере.",
  },
  livecam_faq_h: {
    es: "Preguntas frecuentes", en: "Frequently asked questions", fr: "Questions fréquentes", de: "Häufige Fragen", zh: "常见问题", it: "Domande frequenti", ru: "Частые вопросы",
  },
  livecam_q1: {
    es: "¿Es esta la única cámara de surf en vivo de Popoyo?", en: "Is this the only live surf cam in Popoyo?", fr: "Est-ce la seule webcam de surf en direct à Popoyo ?", de: "Ist dies die einzige Live-Surf-Cam in Popoyo?", zh: "这是波波约唯一的实时冲浪摄像头吗？", it: "È l'unica webcam di surf in diretta a Popoyo?", ru: "Это единственная прямая сёрф-камера в Попойо?",
  },
  livecam_a1: {
    es: "Sí — actualmente esta es la única transmisión de surf en vivo disponible en línea para Popoyo y toda la costa de Tola.",
    en: "Yes — this is currently the only live surf stream available online for Popoyo and the wider Tola coast.",
    fr: "Oui — c'est actuellement le seul stream de surf en direct disponible en ligne pour Popoyo et l'ensemble de la côte de Tola.",
    de: "Ja — dies ist derzeit der einzige online verfügbare Live-Surf-Stream für Popoyo und die gesamte Küste von Tola.",
    zh: "是的——目前这是波波约及整个托拉海岸唯一可在线观看的实时冲浪直播。",
    it: "Sì — attualmente questo è l'unico stream di surf in diretta disponibile online per Popoyo e per l'intera costa di Tola.",
    ru: "Да — на данный момент это единственная прямая сёрф-трансляция, доступная онлайн для Попойо и всего побережья Толы.",
  },
  livecam_q2: {
    es: "¿Es gratis ver la cámara de surf de Popoyo?", en: "Is the Popoyo surf cam free to watch?", fr: "La webcam de surf de Popoyo est-elle gratuite ?", de: "Ist die Popoyo-Surf-Cam kostenlos?", zh: "观看波波约冲浪摄像头免费吗？", it: "La webcam di surf di Popoyo è gratuita?", ru: "Просмотр сёрф-камеры Попойо бесплатный?",
  },
  livecam_a2: {
    es: "Sí, la transmisión en vivo es completamente gratis, aquí mismo en Popoyo.app, en cualquier dispositivo.",
    en: "Yes, the live stream is completely free to watch, right here on Popoyo.app, on any device.",
    fr: "Oui, le stream en direct est entièrement gratuit, ici même sur Popoyo.app, sur n'importe quel appareil.",
    de: "Ja, der Live-Stream ist völlig kostenlos, direkt hier auf Popoyo.app, auf jedem Gerät.",
    zh: "是的，实时直播完全免费，就在 Popoyo.app 上，任何设备均可观看。",
    it: "Sì, lo stream in diretta è completamente gratuito, proprio qui su Popoyo.app, su qualsiasi dispositivo.",
    ru: "Да, прямая трансляция полностью бесплатна, прямо здесь на Popoyo.app, на любом устройстве.",
  },
  livecam_q3: {
    es: "¿Qué ola muestra la cámara?", en: "What break does the camera show?", fr: "Quel spot la caméra montre-t-elle ?", de: "Welchen Break zeigt die Kamera?", zh: "摄像头拍摄的是哪个浪点？", it: "Quale onda mostra la webcam?", ru: "Какой брейк показывает камера?",
  },
  livecam_a3: {
    es: "Muestra el reef de Beginner's Bay / Playa Popoyo, el principal reef break tipo A-frame de la Costa Esmeralda de Nicaragua.",
    en: "It shows the reef at Beginner's Bay / Playa Popoyo, the main A-frame reef break on Nicaragua's Emerald Coast.",
    fr: "Elle montre le reef de Beginner's Bay / Playa Popoyo, le principal reef break en A-frame de la Côte d'Émeraude du Nicaragua.",
    de: "Sie zeigt das Riff an der Beginner's Bay / Playa Popoyo, den wichtigsten A-Frame-Riffbruch an Nicaraguas Smaragdküste.",
    zh: "它拍摄的是 Beginner's Bay / Playa Popoyo 的礁石浪，尼加拉瓜翡翠海岸的主要 A 字形礁石浪点。",
    it: "Mostra il reef di Beginner's Bay / Playa Popoyo, il principale reef break ad A-frame della Costa Smeralda del Nicaragua.",
    ru: "Она показывает риф в Beginner's Bay / Плайя-Попойо — главный A-образный рифовый брейк на Изумрудном берегу Никарагуа.",
  },
  livecam_cta: {
    es: "Ver la guía completa de surf de Popoyo", en: "See the full Popoyo surf guide", fr: "Voir le guide de surf complet de Popoyo", de: "Zum vollständigen Popoyo-Surfguide", zh: "查看完整的波波约冲浪指南", it: "Vedi la guida completa al surf di Popoyo", ru: "Смотреть полный сёрф-гид по Попойо",
  },
  livecam_offline_h: {
    es: "La transmisión está temporalmente fuera de línea", en: "The stream is temporarily offline", fr: "Le stream est temporairement hors ligne", de: "Der Stream ist vorübergehend offline", zh: "直播暂时离线", it: "Lo stream è temporaneamente offline", ru: "Трансляция временно недоступна",
  },
  livecam_offline_p: {
    es: "La cámara suele transmitir durante las horas de luz. Vuelve más tarde para ver las olas de Popoyo en vivo.",
    en: "The camera usually streams during daylight hours. Check back later to watch Popoyo's waves live.",
    fr: "La caméra diffuse généralement en journée. Revenez plus tard pour voir les vagues de Popoyo en direct.",
    de: "Die Kamera überträgt meist bei Tageslicht. Schau später wieder vorbei, um Popoyos Wellen live zu sehen.",
    zh: "摄像头通常在白天直播。请稍后再来观看波波约的实时海浪。",
    it: "La webcam trasmette di solito durante le ore diurne. Torna più tardi per vedere le onde di Popoyo in diretta.",
    ru: "Камера обычно вещает в светлое время суток. Загляните позже, чтобы посмотреть волны Попойо вживую.",
  },
};

export function t(lang, key) {
  const e = T[key];
  if (!e) return key;
  return e[lang] || e.en || key;
}
